<template>
	<v-row>
		<v-col cols="12" class="actions-col">
			<div class="actions">
				<v-btn
					depressed
					outlined
					@click="download"
					:loading="isDownloading"
					:disabled="isDownloading"
				>
					<v-icon class="mr-1" v-if="!isDownloading">mdi-download</v-icon>
					{{ isDownloading ? 'Downloading...' : 'Download' }}
				</v-btn>
				<v-btn depressed outlined @click="showPrintModal = !showPrintModal"
					><v-icon class="mr-1">mdi-printer</v-icon> Print
				</v-btn>
				<v-btn depressed outlined @click="$emit('cancel')">Back</v-btn>
			</div>
		</v-col>

		<v-col v-show="false" cols="12">
			<div v-for="(pickTicket, i) in pickTickets" :key="i">
				<article
					v-if="pickTicket.type?.toLowerCase() === 'processing'"
					:class="`print-${pickTicket.pickTicketId}`"
				>
					<div class="print-wrapper">
						<!-- Page identification footer for pagination - PagedJS moves this to margin -->
						<div class="page-id-footer">
							<span class="doc-id">PT-{{ pickTicket.pickTicketId }}</span>
							<span class="separator"> | </span>
							<span class="page-number"></span>
							<span class="separator"> | </span>
							<span class="printed-info">Printed on {{ currentDate }} at {{ currentTime }} {{ printedBy }}</span>
						</div>
						<section class="print-heading">
							<div class="print-heading-left">
								<p>
									<b>TeamLeader</b>
								</p>

								<p>
									2901 Summit Ave. #300
									<br />
									Plano, TX 75074
								</p>

								<p>Phone: 1-877-365-7555</p>
							</div>

							<div class="print-heading-center">
								<div class="print-heading-logo">
									<img
										src="data:image/svg+xml;base64,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"
										alt="teamleader logo"
									/>
								</div>
							</div>

							<div class="print-heading-right">
								<span class="print-heading-type"
									>PROCESSING PICK TICKET #{{ pickTicket.pickTicketId }}</span
								>

								<p>
									<b>Sales Order #{{ printInfo.orderNumber }}</b>
								</p>

								<!-- <p>Page 1</p> -->
								<div id="print-header">Page</div>
							</div>
						</section>

						<!-- No barcode on Processing tickets: they are never shipped, the shipper scans the
						     Normal ticket that replaces them (#1471). -->
						<section class="print-info">
							<div class="print-info-container-split po-badge-container">
								<div
									v-for="(po, i) in renderPendingPOs([pickTicket.purchaseOrder])"
									:key="i"
									class="po-badge"
								>
									PO# {{ po.number }}
								</div>
							</div>

							<div class="print-info-container-split">
								<table>
									<thead>
										<tr>
											<th>Ship To</th>
										</tr>
									</thead>
									<tbody>
										<tr>
											<td>
												<p><b>TeamLeader</b></p>
												<p>2901 Summit Ave. #300</p>
												<p>Plano, TX 75074</p>
												<p>Phone: 1-877-365-7555</p>
												<p>&nbsp;</p>
												<p>&nbsp;</p>
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</section>

						<section class="print-items">
							<div class="print-items-container">
								<table>
									<thead>
										<tr>
											<th>Line #</th>
											<th>BIN</th>
											<th>Item #</th>
											<th>Description</th>
											<th>Qty</th>
										</tr>
									</thead>
									<tbody>
										<template v-for="(item, idx) in getOrderedItemsAboveDivider(pickTicket.purchaseOrder, pickTicket)">
											<!-- Main Item -->
											<tr v-if="item._type === 'item'" :key="`item-${idx}`">
												<td><span style="display: inline-block; width: 20px; height: 20px; vertical-align: middle;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20"><path fill="currentColor" d="M16,4L9,8.04V15.96L16,20L23,15.96V8.04M16,6.31L19.8,8.5L16,10.69L12.21,8.5M0,7V9H7V7M11,10.11L15,12.42V17.11L11,14.81M21,10.11V14.81L17,17.11V12.42M2,11V13H7V11M4,15V17H7V15"/></svg></span></td>
												<td>
													<p>{{ item.bin || '' }}</p>
												</td>
												<td>
													<p v-if="getItemIsAttaching(item, pickTicket)" class="print-items-title">
														ATTACH
													</p>
													<p v-else class="print-items-title">
														{{
															(
																processTypes.find(
																	(pt) =>
																		pt.processTypeId ===
																		(item?.itemOrdered?.processTypeId ?? item?.processTypeId)
																)?.name || ""
															).toUpperCase()
														}}
													</p>
													<p class="print-items-title">
														<span
																v-if="
																	$systemCategories.isSubItem(
																		item?.itemOrdered?.systemCategoryId ?? item.systemCategoryId
																	)
																"
																style="display: inline-block; width: 20px; height: 20px; vertical-align: middle; margin-right: 12px;"
															><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20"><path fill="currentColor" d="M19,15L13,21L11.58,19.58L15.17,16H4V4H6V14H15.17L11.58,10.42L13,9L19,15Z"/></svg></span>
														{{ item.itemOrdered?.vendorPartNumber || item.styleCode }}
														<span
															class="print-items-received"
															v-if="
																getItemReceivedItems(item, pickTicket) &&
																getItemReceivedItems(item, pickTicket)?.length > 0 &&
																getItemReceivedItems(item, pickTicket)?.reduce(
																	(sum, ri) => sum + ri.quantityReceived,
																	0
																) > 0
															"
														>
															(Received
															{{
																formatMostRecentReceivedDate(
																	getItemReceivedItems(item, pickTicket)
																)
															}})
														</span>
													</p>
													<p>&nbsp;</p>
												</td>
												<td>
													<p v-if="getItemIsAttaching(item, pickTicket)" class="print-items-title">
														Attach {{ item.itemOrdered?.systemCategory }} to
														{{ item.parentItem?.itemOrdered?.systemCategory }}
													</p>
													<p v-else class="print-items-title">
														{{
															(
																processTypes.find(
																	(pt) =>
																		pt.processTypeId ===
																		(item?.itemOrdered?.processTypeId ?? item?.processTypeId)
																)?.description || ""
															).toUpperCase()
														}}
													</p>
													<p
														v-if="getItemPurchaseOrderNumber(item, pickTicket)"
														class="print-items-title"
													>
														Order# {{ getItemPurchaseOrderNumber(item, pickTicket) }}
													</p>
													<p class="print-items-title">{{ item.description }}</p>
													<p v-if="item.braidPosition" class="print-items-title">
														{{ item.braidPosition }}
													</p>
													<p
														style="font-weight: normal; font-style: italic"
														v-if="item.note"
														v-html="formatNewLines(item.note)"
													></p>
													<template
														v-if="(item.colorSelections && item.colorSelections.length > 0) || (item.freeTextSelections && item.freeTextSelections.length > 0)"
													>
														<p
															v-for="(color, colorIdx) in mergeAndSortSelections(item)"
															:key="`proc-color-${idx}-${colorIdx}`"
														>
															{{ renderColorOption(color, item.colorOptions || []) }}
														</p>
													</template>
													<span v-if="item.matchPreviousPoNumber">
														Previous PO: #{{ item.matchPreviousPoNumber }}
													</span>
													<template v-if="item.lettering && item.lettering.text">
														<p v-if="item.lettering.letterPositionId">
															{{
																letterPositions.find(
																	(lp) => lp.letterPositionId === item.lettering.letterPositionId
																)?.description || ''
															}}
														</p>
														<p>"{{ item.lettering.text }}"</p>
													</template>
													<p
													v-if="
														(item.sizeSelections && item.sizeSelections.length > 0) ||
														(item.specialSizeSelections && item.specialSizeSelections.length > 0)
													"
												>
														<template
														v-for="(size, sizeIndex) in mergeAndSortAllSizes(item)"
													>
														<span :key="sizeIndex" class="size-item">{{
															size
														}}<template
															v-if="sizeIndex < mergeAndSortAllSizes(item).length - 1"
															>,
														</template></span>
													</template>
													</p>
												</td>
												<td>
													<p class="print-items-value">{{ item.quantity }}</p>
												</td>
											</tr>

											<!-- Stock Child -->
											<tr v-else-if="item._type === 'stockChild'" :key="`stockChild-${idx}`">
												<td><span style="display: inline-block; width: 20px; height: 20px; vertical-align: middle;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20"><path fill="currentColor" d="M16,4L9,8.04V15.96L16,20L23,15.96V8.04M16,6.31L19.8,8.5L16,10.69L12.21,8.5M0,7V9H7V7M11,10.11L15,12.42V17.11L11,14.81M21,10.11V14.81L17,17.11V12.42M2,11V13H7V11M4,15V17H7V15"/></svg></span></td>
												<td>
													<p>{{ item.bin || '' }}</p>
												</td>
												<td>
													<p class="print-items-title">
														<span style="display: inline-block; width: 20px; height: 20px; vertical-align: middle; margin-right: 12px;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20"><path fill="currentColor" d="M19,15L13,21L11.58,19.58L15.17,16H4V4H6V14H15.17L11.58,10.42L13,9L19,15Z"/></svg></span>
														{{ item.styleCode }}
													</p>
													<p>&nbsp;</p>
												</td>
												<td>
													<p class="print-items-title">{{ item.description }}</p>
													<p v-if="item.braidPosition" class="print-items-title">
														{{ item.braidPosition }}
													</p>
													<p
														style="font-weight: normal; font-style: italic"
														v-if="item.note"
														v-html="formatNewLines(item.note)"
													></p>
												</td>
												<td>
													<p v-if="!item.braidPosition" class="print-items-value">{{ item.quantity }}</p>
												</td>
											</tr>

											<!-- Received Sub-Item (from sibling/child POs) -->
											<tr v-else-if="item._type === 'subItem'" :key="`subItem-${idx}`">
												<td><span style="display: inline-block; width: 20px; height: 20px; vertical-align: middle;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20"><path fill="currentColor" d="M16,4L9,8.04V15.96L16,20L23,15.96V8.04M16,6.31L19.8,8.5L16,10.69L12.21,8.5M0,7V9H7V7M11,10.11L15,12.42V17.11L11,14.81M21,10.11V14.81L17,17.11V12.42M2,11V13H7V11M4,15V17H7V15"/></svg></span></td>
												<td>
													<p>{{ item.bin || '' }}</p>
												</td>
												<td>
													<p v-if="item.isAttaching" class="print-items-title">ATTACH</p>
													<p
														v-else-if="item.itemOrdered?.processTypeId"
														class="print-items-title"
													>
														{{
															(
																processTypes.find(
																	(pt) => pt.processTypeId === item.itemOrdered?.processTypeId
																)?.name || ""
															).toUpperCase()
														}}
													</p>
													<p class="print-items-title">
														<span style="display: inline-block; width: 20px; height: 20px; vertical-align: middle; margin-right: 12px;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20"><path fill="currentColor" d="M19,15L13,21L11.58,19.58L15.17,16H4V4H6V14H15.17L11.58,10.42L13,9L19,15Z"/></svg></span>
														{{
															item.itemOrdered?.vendorPartNumber ||
															item.vendorPartNumber ||
															item?.itemOrdered?.styleCode ||
															item.styleCode
														}}
														<span
															class="print-items-received"
															v-if="
																getChildReceivedItems(item)?.reduce(
																	(sum, ri) => sum + ri.quantityReceived,
																	0
																) > 0
															"
														>
															(Received
															{{ formatMostRecentReceivedDate(getChildReceivedItems(item)) }})
														</span>
													</p>
													<p>&nbsp;</p>
												</td>
												<td>
													<p v-if="item.isAttaching" class="print-items-title">
														Attach
														{{
															item?.itemOrdered?.systemCategory ||
															$systemCategories.getSystemCategory(item.systemCategoryId)?.name
														}}
														to
														{{
															(item.parentSystemCategoryId ? $systemCategories.getSystemCategory(item.parentSystemCategoryId)?.name : null) ||
															'Parent'
														}}
													</p>
													<p class="print-items-title">Order# {{ item.orderNumber }}</p>
													<p class="print-items-title">{{ item.itemOrdered?.description }}</p>
													<p v-if="item.braidPosition" class="print-items-title">
														{{ item.braidPosition }}
													</p>
													<p
														style="font-weight: normal; font-style: italic"
														v-if="item.note"
														v-html="formatNewLines(item.note)"
													></p>
													<template
														v-if="(item.colorSelections && item.colorSelections.length > 0) || (item.freeTextSelections && item.freeTextSelections.length > 0)"
													>
														<p
															v-for="(color, cidx) in mergeAndSortSelections(item)"
															:key="`subcolor-${idx}-${cidx}`"
														>
															{{ renderColorOption(color, item.inventoryItem?.colorOptions || item.colorOptions || []) }}
														</p>
													</template>
													<p v-if="item.matchPreviousPoNumber">
														Previous PO: #{{ item.matchPreviousPoNumber }}
													</p>
													<template v-if="item.lettering && item.lettering.text">
														<p v-if="item.lettering.letterPositionId">
															{{
																letterPositions.find(
																	(lp) =>
																		lp.letterPositionId === item.lettering.letterPositionId
																)?.description || ''
															}}
														</p>
														<p>"{{ item.lettering.text }}"</p>
													</template>
													<p v-if="(item.sizeSelections && item.sizeSelections.length > 0) || (item.specialSizeSelections && item.specialSizeSelections.length > 0)">
														<template v-for="(size, sizeIndex) in mergeAndSortAllSizes(item)">
															<span :key="sizeIndex" class="size-item">{{ size }}<template v-if="sizeIndex < mergeAndSortAllSizes(item).length - 1">, </template></span>
														</template>
													</p>
												</td>
												<td>
													<p v-if="!item.braidPosition" class="print-items-value">{{ item.quantity }}</p>
												</td>
											</tr>

											<!-- Processing: Show pending work (only once, after all above-divider items) -->
											<tr
												v-if="idx === getOrderedItemsAboveDivider(pickTicket.purchaseOrder, pickTicket).length - 1 && getFilteredWorkToBeDone(pickTicket.purchaseOrder)?.length > 0"
												class="print-divider"
												style="background-color: lightgray"
												:key="`processing-header-${idx}`"
											>
												<td colspan="5" style="padding: 4px !important">Work to be done</td>
											</tr>
											<template v-if="idx === getOrderedItemsAboveDivider(pickTicket.purchaseOrder, pickTicket).length - 1 && getFilteredWorkToBeDone(pickTicket.purchaseOrder)?.length > 0">
												<tr
													v-for="(subItem, sidx) in getFilteredWorkToBeDone(pickTicket.purchaseOrder)"
													:key="`processSubItem-${idx}-${sidx}`"
												>
													<td></td>
													<td></td>
													<td>
														<p v-if="subItem.isAttaching" class="print-items-title">ATTACH</p>
														<p
															v-else-if="subItem.itemOrdered?.processTypeId"
															class="print-items-title"
														>
															{{
																(
																	processTypes.find(
																		(pt) => pt.processTypeId === subItem.itemOrdered?.processTypeId
																	)?.name || ""
																).toUpperCase()
															}}
														</p>
														<p class="print-items-title">
															<span v-if="!subItem.isParentItem" style="display: inline-block; width: 20px; height: 20px; vertical-align: middle; margin-right: 12px;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20"><path fill="currentColor" d="M19,15L13,21L11.58,19.58L15.17,16H4V4H6V14H15.17L11.58,10.42L13,9L19,15Z"/></svg></span>
															{{
																subItem.itemOrdered?.vendorPartNumber ||
																subItem.vendorPartNumber ||
																subItem.itemOrdered?.styleCode ||
																subItem.styleCode
															}}
														</p>
														<p>&nbsp;</p>
													</td>
													<td>
														<p v-if="subItem.isAttaching" class="print-items-title">
															Attach
															{{
																subItem?.itemOrdered?.systemCategory ||
																$systemCategories.getSystemCategory(subItem.systemCategoryId)?.name
															}}
															to
															{{
																(subItem.parentSystemCategoryId ? $systemCategories.getSystemCategory(subItem.parentSystemCategoryId)?.name : null) ||
																item?.itemOrdered?.systemCategory ||
																$systemCategories.getSystemCategory(item.systemCategoryId)?.name
															}}
														</p>
														<p class="print-items-title">
															Order# {{ subItem.purchaseOrderNumber }}
														</p>
														<p class="print-items-title">{{ subItem.itemOrdered?.description }}</p>
														<p v-if="subItem.braidPosition" class="print-items-title">
															{{ subItem.braidPosition }}
														</p>
														<p
															style="font-weight: normal; font-style: italic"
															v-if="subItem.note"
															v-html="formatNewLines(subItem.note)"
														></p>
														<template
															v-if="(subItem.colorSelections && subItem.colorSelections.length > 0) || (subItem.freeTextSelections && subItem.freeTextSelections.length > 0)"
														>
															<p
																v-for="(color, cidx) in mergeAndSortSelections(subItem)"
																:key="`work-color-${cidx}`"
															>
																{{ renderColorOption(color, subItem.inventoryItem?.colorOptions || subItem.colorOptions || []) }}
															</p>
														</template>
														<p v-if="subItem.matchPreviousPoNumber">
															Previous PO: #{{ subItem.matchPreviousPoNumber }}
														</p>
														<template v-if="subItem.lettering && subItem.lettering.text">
															<p v-if="subItem.lettering.letterPositionId">
																{{
																	letterPositions.find(
																		(lp) =>
																			lp.letterPositionId === subItem.lettering.letterPositionId
																	)?.description || ''
																}}
															</p>
															<p>"{{ subItem.lettering.text }}"</p>
														</template>
														<p v-if="(subItem.sizeSelections && subItem.sizeSelections.length > 0) || (subItem.specialSizeSelections && subItem.specialSizeSelections.length > 0)">
															<template v-for="(size, sizeIndex) in mergeAndSortAllSizes(subItem)">
																<span :key="sizeIndex" class="size-item">{{ size }}<template v-if="sizeIndex < mergeAndSortAllSizes(subItem).length - 1">, </template></span>
															</template>
														</p>
													</td>
													<td>
														<template v-if="!subItem.braidPosition">{{ subItem.quantity }}</template>
													</td>
												</tr>
											</template>
										</template>
									</tbody>
								</table>
							</div>
						</section>
						<section class="print-rep-prices">
							<div class="print-total-container">
								<table class="print-rep-prices-table" style="width: 100%">
									<tr>
										<td>
											<div class="print-rep-info-container">
												Teamleader proudly makes all custom uniforms in the USA!
											</div>
										</td>
									</tr>
								</table>
								<table class="print-total-table">
									<thead>
										<tr>
											<th>
												Total Qty:
												{{ getProcessingTotalQty(pickTicket) }}
											</th>
										</tr>
									</thead>
								</table>
							</div>
						</section>
						<section class="print-footer">
							<div class="print-footer-container">
								<div class="print-footer-left">
									<table class="print-footer-table">
										<thead>
											<tr>
												<th>{{ renderShippingMethod(printInfo.shippingMethodId) }}</th>
											</tr>
										</thead>
										<!-- Print info now included in page-id-footer which appears on every page -->
									</table>
								</div>
								<div>
									<span>Inspected by ______________ and ______________</span>
								</div>
							</div>
						</section>
					</div>
				</article>
				<article v-else :class="`print-${pickTicket.pickTicketId}`">
					<div class="print-wrapper">
						<!-- Page identification footer for pagination - PagedJS moves this to margin -->
						<div class="page-id-footer">
							<span class="doc-id">PT-{{ pickTicket.pickTicketId }}</span>
							<span class="separator"> | </span>
							<span class="page-number"></span>
							<span class="separator"> | </span>
							<span class="printed-info">Printed on {{ currentDate }} at {{ currentTime }} {{ printedBy }}</span>
						</div>
						<section class="print-heading">
							<div class="print-heading-left">
								<p>
									<b>TeamLeader</b>
								</p>

								<p>
									2901 Summit Ave. #300
									<br />
									Plano, TX 75074
								</p>

								<p>Phone: 1-877-365-7555</p>
							</div>

							<div class="print-heading-center">
								<div class="print-heading-logo">
									<img
										src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2NjQuMiA2Ni4yMSI+CiAgPGRlZnM+CiAgICA8c3R5bGU+CiAgICAgIC5jbHMtMSB7CiAgICAgICAgZmlsbC1ydWxlOiBldmVub2RkOwogICAgICB9CgogICAgICAuY2xzLTEsIC5jbHMtMiB7CiAgICAgICAgZmlsbDogI2JkMjEyODsKICAgICAgICBzdHJva2Utd2lkdGg6IDBweDsKICAgICAgfQogICAgPC9zdHlsZT4KICA8L2RlZnM+CiAgPHBhdGggY2xhc3M9ImNscy0xIiBkPSJtNjQuNTgsNi42NmwuOTItNi4xNUgyLjg3bC0uOTIsNi4xNWg2Mi42M1ptLTM3LjYzLDUuOTVIMS4wNmwtMS4wNiw3LjExaDExLjc3bC03LjU3LDQ2LjQ5aDcuMjlsNy41Ni00Ni40OWg2LjczbC03LjU4LDQ2LjQ5aDYuNjlsNy41NS00Ni40OWgxMC42NmwtNy41NCw0Ni40OWgzOC44OWwxLjMtOWgtMzIuMjNsNy4yNi00NC42M2gtMjMuODN2LjAzWm00OS43NSwzOC4xbC44Mi01LjYzaC0xOC44NWw1LjI4LTMyLjQ3aC02LjQ1bC02LjE5LDM4LjFoMjUuMzlaIi8+CiAgPHBhdGggY2xhc3M9ImNscy0yIiBkPSJtNjY0LjIsNS4yNmMuMDMsMS4zNC0uNDcsMi42NC0xLjM4LDMuNjMtMS42NCwxLjg0LTQuNDUsMi4wMS02LjMuMzctLjEzLS4xMi0uMjYtLjI0LS4zNy0uMzctMS44NC0yLjA3LTEuODQtNS4xOSwwLTcuMjYsMS42Mi0xLjg0LDQuNDItMi4wMiw2LjI3LS40LjE0LjEzLjI4LjI2LjQuNC45MS45OCwxLjQxLDIuMjksMS4zOCwzLjYzWm0tLjYzLDBjLjAyLTEuMTctLjQxLTIuMy0xLjItMy4xNi0xLjM3LTEuNTktMy43OC0xLjc3LTUuMzctLjQtLjE0LjEyLS4yNy4yNS0uNC40LTEuNiwxLjgtMS42LDQuNTIsMCw2LjMyLDEuMzksMS41OSwzLjgxLDEuNzYsNS40LjM3LjEzLS4xMS4yNS0uMjQuMzctLjM3LjgtLjg2LDEuMjQtMS45OSwxLjIzLTMuMTZoLS4wM1ptLTEsMi42MWgtMS4yMWwtMS44MS0yLjExaC0uODh2Mi4xMWgtLjlWMi40NGgxLjdjLjI4LS4wMi41Ni0uMDIuODQsMCwuMjMuMDQuNDYuMTIuNjYuMjQuMjEuMTEuMzkuMjguNS40OS4xMi4yMi4xNy40Ny4xNi43Mi4wMi4zNi0uMDkuNzEtLjMsMS0uMjMuMjctLjUyLjQ3LS44NS42bDIuMDksMi4zOFptLTEuOTQtMy45MWMwLS4xMy0uMDItLjI2LS4wNy0uMzgtLjA2LS4xMi0uMTUtLjIxLS4yNi0uMjctLjExLS4wNy0uMjMtLjExLS4zNi0uMTMtLjE2LS4wMS0uMzItLjAxLS40OCwwaC0uODF2MS44M2guNjljLjE5LjAyLjM5LjAyLjU4LDAsLjE1LS4wMy4yOS0uMS40MS0uMi4xMS0uMDguMTktLjE5LjIzLS4zMi4wNi0uMTcuMDktLjM1LjA3LS41M1oiLz4KICA8cG9seWdvbiBjbGFzcz0iY2xzLTIiIHBvaW50cz0iMTAwLjkzIDY1LjcyIDg2LjI3IDY1LjcyIDk0Ljc2IDE1LjExIDc5LjE3IDE1LjExIDgxLjczIC4wMiAxMjYuODYgLjAyIDEyNC4zIDE1LjExIDEwOS40MiAxNS4xMSAxMDAuOTMgNjUuNzIiLz4KICA8cG9seWdvbiBjbGFzcz0iY2xzLTIiIHBvaW50cz0iMTY3LjY5IDY1Ljg0IDEyNS43NyA2NS44NCAxMzYuNzQgLjE0IDE3OC4zMSAuMTQgMTc1Ljg0IDE1LjI0IDE0OC44NSAxNS4yNCAxNDcuMjMgMjQuOTIgMTcyLjIxIDI0LjkyIDE2OS43OCAzOS4xNSAxNDQuODEgMzkuMTUgMTQyLjg1IDUwLjc1IDE3MC4yNiA1MC43NSAxNjcuNjkgNjUuODQiLz4KICA8cG9seWdvbiBjbGFzcz0iY2xzLTIiIHBvaW50cz0iMjk5Ljk2IDY1Ljg0IDI4Ni4wMyA2NS44NCAyOTIuNjQgMjkuNzggMjc3LjI5IDY1Ljg0IDI2Ni4xMSA2NS44NCAyNjIuNTEgMjguOCAyNTYuOTMgNjUuODQgMjQyLjk0IDY1Ljg0IDI1My45OCAuMTQgMjcyLjI3IC4xNCAyNzUuNjQgMzkuNzcgMjkyLjUgLjE0IDMxMS4wNyAuMTQgMjk5Ljk2IDY1Ljg0Ii8+CiAgPHBvbHlnb24gY2xhc3M9ImNscy0yIiBwb2ludHM9IjM1NS4wNSA2NS44NCAzMTYuNDcgNjUuODQgMzI3LjQ0IC4xNCAzNDIuMDkgLjE0IDMzMy42MSA1MC43NSAzNTcuNjEgNTAuNzUgMzU1LjA1IDY1Ljg0Ii8+CiAgPHBvbHlnb24gY2xhc3M9ImNscy0yIiBwb2ludHM9IjQwOSA2NS43MSAzNjcuMDggNjUuNzEgMzc4LjA1IC4wMSA0MTkuNjIgLjAxIDQxNy4xNSAxNS4xMSAzOTAuMTUgMTUuMTEgMzg4LjU0IDI0Ljc5IDQxMy41MSAyNC43OSA0MTEuMDkgMzkuMDIgMzg2LjEyIDM5LjAyIDM4NC4xNSA1MC42MiA0MTEuNTYgNTAuNjIgNDA5IDY1LjcxIi8+CiAgPHBhdGggY2xhc3M9ImNscy0yIiBkPSJtNTA0LjczLDY1Ljg0aC0yMi44N0w0OTIuODYuMTRoMTkuNDhjNy41MywwLDEzLjMxLDIuMzQsMTcuMTgsN3M1LjcxLDEwLjkyLDUuNzEsMTljLjA0LDUuMjItLjU5LDEwLjQzLTEuODcsMTUuNS0xLjExLDQuNTItMy4wMyw4Ljc5LTUuNjYsMTIuNjMtMi40OCwzLjU1LTUuNzcsNi40Ny05LjYsOC41MS00LjE0LDIuMS04LjczLDMuMTUtMTMuMzcsMy4wNlptLTUuNzgtMTUuMWg2LjI1YzIuMjcuMDUsNC41Mi0uNTMsNi40OS0xLjY2LDEuOTUtMS4xNiwzLjYtMi43Niw0LjgzLTQuNjYsMS40Mi0yLjE4LDIuNDYtNC41OSwzLjEtNy4xMS43NC0yLjg5LDEuMTEtNS44NiwxLjA5LTguODQuMDItMS45My0uMTctMy44Ni0uNTUtNS43NS0uMjktMS40Ni0uODYtMi44Ni0xLjY2LTQuMTItLjY3LTEuMDUtMS42MS0xLjkxLTIuNzEtMi40OS0xLjI4LS42Mi0yLjctLjkyLTQuMTItLjg4aC02LjY3bC02LjA1LDM1LjUxWiIvPgogIDxwb2x5Z29uIGNsYXNzPSJjbHMtMiIgcG9pbnRzPSI1ODUuOSA2NS43MiA1NDMuOTcgNjUuNzIgNTU0Ljk0IC4wMiA1OTYuNTEgLjAyIDU5NC4wNCAxNS4xMSA1NjcuMDUgMTUuMTEgNTY1LjQzIDI0LjggNTkwLjQxIDI0LjggNTg3Ljk4IDM5LjAzIDU2My4wMSAzOS4wMyA1NjEuMDUgNTAuNjIgNTg4LjQ2IDUwLjYyIDU4NS45IDY1LjcyIi8+CiAgPHBhdGggY2xhc3M9ImNscy0yIiBkPSJtNjQ4LjM2LDY1LjcxaC0xNC41OGwtLjI3LTEuNDdjLS4xNS0uNzktLjI3LTEuNTItLjM2LTIuMjItLjExLS43Ni0uMTYtMS41Mi0uMTYtMi4yOSwwLTIuMTMuMDktNC4zMS4yOC02LjQ2cy4yNy00LjEzLjI3LTYuMTVjLjAzLTEuMDQtLjEtMi4wOC0uNDEtMy4wNy0uMi0uNjEtLjU0LTEuMTYtMS0xLjYtLjQxLS4zNy0uOS0uNjItMS40NC0uNzQtLjgyLS4xOC0xLjY3LS4yNi0yLjUxLS4yNWgtOC43N2wtNC4xLDI0LjI1aC0xNC41MUw2MTEuOC4wMWgyNS4yYzIuMjQtLjA3LDQuNDguMiw2LjYzLjgyLDIuMDYuNjEsMy45NCwxLjcyLDUuNDYsMy4yNCwxLjU4LDEuNjQsMi43NSwzLjYyLDMuNDIsNS43OS44MiwyLjY2LDEuMiw1LjQ0LDEuMTQsOC4yMiwwLDIuMi0uMyw0LjM5LS45MSw2LjUxLS41NiwyLTEuNDUsMy44OS0yLjYxLDUuNjEtMS4xLDEuNi0yLjQ4LDMuMDEtNC4wNiw0LjE0LS41Ni4zOC0xLjE0LjcxLTEuNzUsMSwuODcuOTEsMS41MiwxLjk5LDEuOTIsMy4xOC43OSwyLjM3LDEuMTgsNC44NSwxLjE1LDcuMzQsMCwxLjQxLS4wNiwzLjEzLS4xOCw1LjFzLS4xNywzLjgxLS4xNyw1LjY4YzAsMS4zNSwwLDIuNjMuMTMsMy44Mi4wNi45Ny4yMywxLjkzLjQ5LDIuODdsLjcsMi4zOFptLTI2LjY2LTM3LjYxaDhjMS4yNywwLDIuNTMtLjE2LDMuNzUtLjUsMS4wOC0uMjksMi4xLS43OCwzLTEuNDQuODUtLjYzLDEuNTMtMS40NiwyLTIuNDEuNTMtMS4xNS43OS0yLjQuNzUtMy42Ny4wNS0xLjEzLS4xMi0yLjI2LS41MS0zLjMyLS4yNC0uNjEtLjY0LTEuMTUtMS4xNi0xLjU1LS41NS0uMzgtMS4xOS0uNjMtMS44NS0uNzQtLjkxLS4xNi0xLjgyLS4yMy0yLjc0LS4yM2gtOC44M2wtMi40MSwxMy44NloiLz4KICA8cGF0aCBjbGFzcz0iY2xzLTIiIGQ9Im00NzEuMjYsNjUuOGgtMTQuNTNsLTEuNi0xMy44NGgtMTUuNzlsLTYuMjYsMTMuODNoLTE1LjVMNDQ4LjU4LjA5aDEzLjkybDguNzYsNjUuNzFabS0yOC40NS0yNy4xMWgxMi4wN2wtMi4yNC0yMi42Ny05LjgzLDIyLjY3WiIvPgogIDxwYXRoIGNsYXNzPSJjbHMtMiIgZD0ibTIzMS40OSw2NS44MmgtMTQuNTNsLTEuNi0xMy44NmgtMTUuOGwtNi4yNiwxMy44M2gtMTUuNDlMMjA4LjgxLjA4aDEzLjkzbDguNzUsNjUuNzRabS0yOC4yOS0yNi42MWgxMi4wN2wtMi4yMy0yMi42OC05Ljg0LDIyLjY4WiIvPgo8L3N2Zz4="
										alt="teamleader logo"
									/>
								</div>
							</div>

							<div class="print-heading-right">
								<span class="print-heading-type">PICK TICKET #{{ pickTicket.pickTicketId }}</span>

								<p>
									<b>Sales Order #{{ printInfo.orderNumber }}</b>
								</p>

								<!-- <p>Page 1</p> -->
								<div id="print-header">Page</div>
							</div>
						</section>

						<section class="barcode">
							<svg :ref="`barcode-${pickTicket.pickTicketId}`"></svg>
						</section>

						<section class="print-info">
							<div class="print-info-container-split">
								<table>
									<thead>
										<tr>
											<th>Sold To: (Customer # {{ printInfo.customerNumber }})</th>
										</tr>
									</thead>
									<tbody>
										<tr>
											<td>
												<p>{{ computedAddress.contactName }}</p>
												<p>{{ computedAddress.organization }}</p>
												<p v-if="computedAddress.department">{{ computedAddress.department }}</p>
												<p>{{ computedAddress.address }}</p>
												<p class="addr-city-state">{{ computedAddress.cityState }}</p>

												<p v-if="computedAddress.contactEmail" style="font-size: 9pt">{{ computedAddress.contactEmail }}</p>
												<p v-if="computedAddress.contactWorkPhone" style="font-size: 9pt">Work: {{ computedAddress.contactWorkPhone }}</p>
												<p v-if="computedAddress.contactCellPhone" style="font-size: 9pt">Cell: {{ computedAddress.contactCellPhone }}</p>
											</td>
										</tr>
									</tbody>
								</table>
							</div>

							<div class="print-info-container-split">
								<table>
									<thead>
										<tr>
											<th>Ship To: (Customer # {{ printInfo.customerNumber }})</th>
										</tr>
									</thead>
									<tbody>
										<tr>
											<td>
												<p>{{ computedShipTo.contactName }}</p>
												<p>{{ computedShipTo.organization }}</p>
												<p>{{ computedShipTo.address }}</p>
												<p class="addr-city-state">{{ computedShipTo.cityState }}</p>

												<p v-if="computedShipTo.contactEmail" style="font-size: 9pt">{{ computedShipTo.contactEmail }}</p>
												<p v-if="computedShipTo.contactWorkPhone" style="font-size: 9pt">Work: {{ computedShipTo.contactWorkPhone }}</p>
												<p v-if="computedShipTo.contactCellPhone" style="font-size: 9pt">Cell: {{ computedShipTo.contactCellPhone }}</p>
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</section>

						<section class="print-info">
							<div class="print-info-container-full">
								<table>
									<thead>
										<tr>
											<th>Ship Date</th>
											<th>Payment Type</th>
											<th>Rep</th>
											<th>School PO #</th>
											<th>Ship Via</th>
										</tr>
									</thead>
									<tbody>
										<tr>
											<td>
												<p>{{ formatDate(pickTicket.shipDate) }}</p>
											</td>
											<td>
												<p>{{ renderPaymentTerms(printInfo.paymentTermsId) }}</p>
											</td>
											<td>
												<p>{{ renderSalesRep(printInfo.salesRepId, "name") }}</p>
											</td>
											<td>
												<p>{{ printInfo.schoolPo }}</p>
											</td>
											<td>
												<p>{{ renderShippingMethod(printInfo.shippingMethodId) }}</p>
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</section>

						<section class="print-items">
							<div class="print-items-container">
								<table>
									<thead>
										<tr>
											<th>Line #</th>
											<th>BIN</th>
											<th>Item #</th>
											<th>Description</th>
											<th>Qty</th>
										</tr>
									</thead>
									<tbody>
										<template v-for="(lineItem, i) in pickTicket.items">
											<tr :key="i">
												<td>{{ getLineNumber(lineItem.lineItemId) }}</td>
												<td class="print-items-title">{{ lineItem.bin || '' }}</td>
												<td>
													<p class="print-items-title">{{ lineItem.styleCode }}</p>
												</td>
												<td>
													<p class="print-items-title">
														{{ lineItem.description }}
													</p>
													<p
														style="font-weight: normal; font-style: italic"
														v-if="lineItem.note"
														v-html="formatNewLines(lineItem.note)"
													></p>
													<p v-if="lineItem.braidPosition" class="print-items-title">
														{{ lineItem.braidPosition }}
													</p>
													<template
														v-if="(lineItem.colorSelections && lineItem.colorSelections.length > 0) || (lineItem.freeTextSelections && lineItem.freeTextSelections.length > 0)"
													>
														<p
															v-for="(color, colorIndex) in mergeAndSortSelections(lineItem)"
															:key="`merged-color-${i}-${colorIndex}`"
														>
															{{ renderColorOption(color, lineItem.inventoryItem?.colorOptions || lineItem.colorOptions) }}
														</p>
													</template>
													<span v-if="lineItem.matchPreviousPoNumber">
														Previous PO: #{{ lineItem.matchPreviousPoNumber }}
													</span>
													<template v-if="lineItem.lettering">
														<p>
															{{ lineItem.lettering.description }}
														</p>
														<p>"{{ lineItem.lettering.text }}"</p>
													</template>
													<p
													v-if="
														(lineItem.sizeSelections && lineItem.sizeSelections.length > 0) ||
														(lineItem.specialSizeSelections && lineItem.specialSizeSelections.length > 0)
													"
												>
														<template
														v-for="(size, sizeIndex) in mergeAndSortAllSizes(lineItem)"
													>
														<span :key="sizeIndex" class="size-item">{{
															size
														}}<template
															v-if="sizeIndex < mergeAndSortAllSizes(lineItem).length - 1"
															>,
														</template></span>
													</template>
													</p>
												</td>
												<td>
													<p class="print-items-value">{{ lineItem.quantity }}</p>
												</td>
											</tr>
											<tr v-for="(childItem, j) in lineItem.children" :key="`child-${i}-${j}`">
												<td>{{ childItem.lineNumber }}</td>
												<td class="print-items-title">{{ childItem.bin || '' }}</td>
												<td>
													<p class="print-items-title">
														<span style="display: inline-block; width: 20px; height: 20px; vertical-align: middle; margin-right: 12px;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20"><path fill="currentColor" d="M19,15L13,21L11.58,19.58L15.17,16H4V4H6V14H15.17L11.58,10.42L13,9L19,15Z"/></svg></span>{{ childItem.styleCode }}
													</p>
												</td>
												<td>
													<p class="print-items-title">
														{{ childItem.description }}
													</p>
													<p
														style="font-weight: normal; font-style: italic"
														v-if="childItem.note"
														v-html="formatNewLines(childItem.note)"
													></p>
													<p v-if="childItem.braidPosition" class="print-items-title">
														{{ childItem.braidPosition }}
													</p>
													<template
														v-if="(childItem.colorSelections && childItem.colorSelections.length > 0) || (childItem.freeTextSelections && childItem.freeTextSelections.length > 0)"
													>
														<p
															v-for="(color, colorIndex) in mergeAndSortSelections(childItem)"
															:key="colorIndex"
														>
															{{ renderColorOption(color, childItem.inventoryItem?.colorOptions || childItem.colorOptions) }}
														</p>
													</template>
													<span v-if="childItem.matchPreviousPoNumber">
														Previous PO: #{{ childItem.matchPreviousPoNumber }}
													</span>
													<template v-if="childItem.lettering">
														<p>
															{{ childItem.lettering.description }}
														</p>
														<p>"{{ childItem.lettering.text }}"</p>
													</template>
													<p
													v-if="
														(childItem.sizeSelections && childItem.sizeSelections.length > 0) ||
														(childItem.specialSizeSelections && childItem.specialSizeSelections.length > 0)
													"
												>
														<template
														v-for="(size, sizeIndex) in mergeAndSortAllSizes(childItem)"
													>
														<span :key="sizeIndex" class="size-item">{{
															size
														}}<template
															v-if="sizeIndex < mergeAndSortAllSizes(childItem).length - 1"
															>,
														</template></span>
													</template>
													</p>
												</td>
												<td>
													<p v-if="!childItem.braidPosition" class="print-items-value">{{ childItem.quantity }}</p>
												</td>
											</tr>
										</template>
									</tbody>
								</table>
							</div>
						</section>
						<section class="print-rep-prices">
							<div class="print-total-container">
								<table class="print-rep-prices-table" style="width: 100%">
									<tr>
										<td>
											<div class="print-rep-info-container">
												Teamleader proudly makes all custom uniforms in the USA!
											</div>
										</td>
									</tr>
								</table>
								<table class="print-total-table">
									<thead>
										<tr>
											<th>
												Total Qty:
												{{
													pickTicket.items.filter(li => !$systemCategories.isSubItem(li.inventoryItem?.systemCategoryId ?? li.systemCategoryId)).reduce((total, li) => total + (Number(li.quantity) || 0), 0) || pickTicket.items.reduce((total, li) => total + (Number(li.quantity) || 0), 0) || 0
												}}
											</th>
										</tr>
									</thead>
								</table>
							</div>
						</section>
						<section class="print-footer">
							<div class="print-footer-container">
								<div class="print-footer-left">
									<table class="print-footer-table">
										<thead>
											<tr>
												<th>{{ renderShippingMethod(printInfo.shippingMethodId) }}</th>
											</tr>
										</thead>
										<!-- Print info now included in page-id-footer which appears on every page -->
									</table>
								</div>
								<div>
									<span>Inspected by ______________ and ______________</span>
								</div>
							</div>
						</section>
					</div>
				</article>
			</div>
		</v-col>

		<!-- render live print pages from the print article -->
		<v-col cols="12" class="d-flex justify-center">
			<div v-if="loading" class="loading-overlay">
				<div class="loading-dot">&nbsp;</div>
				<div class="loading-dot">&nbsp;</div>
				<div class="loading-dot">&nbsp;</div>
				<div class="loading-dot">&nbsp;</div>
				<div class="loading-dot">&nbsp;</div>
			</div>
			<ul class="no-list-style" style="width: 100%">
				<li v-for="(pickTicket, i) in pickTickets" :key="i">
					<iframe
						:id="`print-frame-${pickTicket.pickTicketId}`"
						:src="pdfUrls[pickTicket.pickTicketId]"
						class="print-frame"
						@load="onPdfIframeLoad(pickTicket.pickTicketId)"
					></iframe>
				</li>
			</ul>
		</v-col>

		<!-- Snackbar for notifications -->
		<v-snackbar v-model="snackbar.show" :color="snackbar.color" :timeout="snackbar.timeout" top>
			<span class="text-h6">{{ snackbar.text || snackbar.message }}</span>
			<template v-slot:action="{ attrs }">
				<v-btn text v-bind="attrs" @click="snackbar.show = false">Close</v-btn>
			</template>
		</v-snackbar>

		<v-overlay :dark="false" :absolute="false" :value="showPrintModal">
			<div class="input-modal print-modal">
				<div class="input-modal-header justify-space-between">
					<span class="ml-3">Print</span>
					<v-btn icon @click="closePrintModal">
						<v-icon v-text="'mdi-close'"></v-icon>
					</v-btn>
				</div>
				<div class="input-modal-content">
					<div class="print-modal-form">
						<div class="form-input">
							<label>Printer:</label>
							<v-select
								v-model="printerSelection"
								:items="printers"
								item-text="text"
								item-value="printerId"
								dense
								outlined
								hide-detail
							></v-select>
						</div>
						<div class="form-input">
							<label>Copies:</label>
							<v-text-field
								class="number-input"
								outlined
								dense
								hide-details="auto"
								v-model="copies"
								type="number"
								min="0"
							></v-text-field>
						</div>
						<div class="form-input">
							<label>Message:</label>
							<v-textarea
								v-model="printMessage"
								dense
								outlined
								hide-details="auto"
								rows="5"
								placeholder="Add optional message or notes for this print job"
								class="message-input"
							></v-textarea>
						</div>
					</div>

					<div class="input-modal-content-actions">
						<v-spacer></v-spacer>
						<div class="button-group">
							<v-btn text @click="closePrintModal" :disabled="isPrinting" class="mr-2">
								Cancel
							</v-btn>
							<v-btn
								color="primary"
								depressed
								@click="print()"
								:loading="isPrinting"
								:disabled="isPrinting || !isFormValid"
							>
								<v-icon left>mdi-printer</v-icon>
								Print
							</v-btn>
						</div>
					</div>
					<v-alert v-if="printResult.show" dense text :type="printResult.type" class="mt-3">
						{{ printResult.message }}
					</v-alert>
				</div>
			</div>
		</v-overlay>

		<!-- Error Dialog -->
		<v-dialog v-model="showErrorDialog" max-width="500" persistent>
			<v-card>
				<v-card-title class="text-h5 error--text">
					<v-icon color="error" class="mr-2">mdi-alert-circle</v-icon>
					Error Loading Pick Ticket
				</v-card-title>

				<v-card-text class="pt-4">
					<p class="text-body-1 mb-2">{{ errorMessage }}</p>

					<v-expansion-panels v-if="errorDetails" flat class="mt-3">
						<v-expansion-panel>
							<v-expansion-panel-header>
								<span class="text-caption">Technical Details</span>
							</v-expansion-panel-header>
							<v-expansion-panel-content>
								<pre class="text-caption">{{ errorDetails }}</pre>
							</v-expansion-panel-content>
						</v-expansion-panel>
					</v-expansion-panels>

					<v-alert type="info" text dense class="mt-3">
						<strong>Suggestions:</strong>
						<ul class="ml-4 mt-2">
							<li>Check your internet connection</li>
							<li>Try refreshing the page</li>
							<li>Contact support if the issue persists</li>
						</ul>
					</v-alert>
				</v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn text @click="$emit('cancel')">Go Back</v-btn>
					<v-btn color="primary" @click="retryLoad">Retry</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>
import gql from "graphql-tag";
import { getItemPrice, renderPrice } from "@/helpers/PricingCalculator";
import { getOrderInfo } from "@/helpers/orderHelper";
import { dedupeSelections } from "@/helpers/selectionHelper";
import {
	PURCHASE_ORDER_BY_ID,
	PURCHASE_ORDER_BY_LINEITEMID,
	SEARCH_PURCHASE_ORDERS,
	GET_PICK_TICKET_PRINT_DATA,
} from "@/gql/queries";
import { GET_INVENTORY_COLOR_OPTIONS_IDS } from "@/gql/inventory";
import { VENDOR_BY_ID } from "@/gql/vendors";
import JsBarcode from "jsbarcode";
import { pagedJSService } from "@/services/PagedJSService";
import { PickTicketSessionCache } from "@/services/PickTicketSessionCache";

/**
 * Inline SVG icons for print templates
 * Using inline SVG to eliminate CDN dependency on Material Design Icons
 */
const INLINE_ICONS = {
	'cube-send': '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20"><path fill="currentColor" d="M16,4L9,8.04V15.96L16,20L23,15.96V8.04M16,6.31L19.8,8.5L16,10.69L12.21,8.5M0,7V9H7V7M11,10.11L15,12.42V17.11L11,14.81M21,10.11V14.81L17,17.11V12.42M2,11V13H7V11M4,15V17H7V15"/></svg>',
	'subdirectory-arrow-right': '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20"><path fill="currentColor" d="M19,15L13,21L11.58,19.58L15.17,16H4V4H6V14H15.17L11.58,10.42L13,9L19,15Z"/></svg>'
};

/**
 * OPTIMIZED VERSION - Uses batch GraphQL query instead of 65+ sequential API calls
 *
 * Key difference from legacy version:
 * - Single GraphQL query consolidates all pick ticket data (order, line items, purchase orders, etc.)
 * - Dramatically reduces API calls from 65+ to 1 for typical pick tickets
 * - Improved performance by eliminating N+1 query patterns
 *
 * For performance comparison, use the toggle in PickTicketStatus component
 */
export default {
	name: "PickTicketPrintTemplateOptimized",
	props: {
		orderId: {
			type: Number,
			default: 0,
		},
		pickTicketIds: {
			type: Array,
			default: () => [],
		},
		// Override for auto-print context where user name is passed via URL
		printedByOverride: {
			type: String,
			default: null,
		},
		skipPreview: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			sessionCache: null, // Session-scoped cache for optimized data fetching
			attribuitions: [
				{ text: "New", attributionId: 1 },
				{ text: "Reorder", attributionId: 2 },
				{ text: "Dealer", attributionId: 3 },
				{ text: "Rep", attributionId: 4 },
				{ text: "E-commission", attributionId: 5 },
				{ text: "Outside Rep", attributionId: 6 },
				{ text: "Web Page", attributionId: 7 },
				{ text: "Unknown", attributionId: 8 },
				{ text: "Return", attributionId: 9 },
			],
			salesReps: [],
			shippingMethods: [],
			paymentTerms: [],
			showPrintModal: false,
			printMessage: "",
			messages: [],
			printerSelection: "",
			printers: [],
			copies: 1,
			isPrinting: false,
			printResult: {
				show: false,
				type: "success",
				message: "",
			},
			printJobId: null,
			snackbar: {
				show: false,
				color: "success",
				text: "",
				timeout: 5000,
			},
			printInfo: {
				salesOrderId: null,
				status: "PENDING",
				organization: "",
				customerId: null,
				contactId: null,
				customerNumber: null,
				quoteNumber: null,
				orderNumber: null,
				schoolPo: "",
				billToId: null,
				shipToId: null,
				shippingMethodId: null,
				paymentTermsId: null,
				processDate: "",
				orderDate: "",
				salesRepId: null,
				referenceNumber: null,
				attribution: null,
				salesTaxId: null,
				orderTotal: 0.0,
				balance: 0.0,
				shippingAndHandling: 0.0,
				shippingAndHandlingDiscount: 0.0,
				payments: [],
				items: [],
				notes: [],
				// pass these to print page
				printPrices: {},
				letterPositions: [],
				salesReps: [],
				paymentMethods: [],
				paymentTerms: [],
				shippingMethods: [],
			},
			lineItems: [],
			computedItemsTable: [],
			pickTickets: [],
			currentDate: this.getCurrentDate(),
			currentTime: this.getCurrentTime(),
			loading: true,
			showErrorDialog: false,
			errorMessage: '',
			errorDetails: '',
			loadingTimeout: false,
			isDownloading: false,
			// PDF preview tracking for auto-print
			pdfUrls: {},
			pdfReadySet: new Set(),
		};
	},
	apollo: {
		messages: {
			query() {
				return gql`
					query {
						message(
							skip: 0
							take: 15
							order: { sequence: ASC }
							where: { orderTypeId: { eq: 2 } }
						) {
							items {
								messageId
								messageIdLabel
								messageContent
								orderTypeId
								sequence
							}
						}
					}
				`;
			},
			update(data) {
				return data.message.items;
			},
		},
		salesReps: {
			query() {
				return gql`
					query {
						salesReps(order: { name: ASC }, take: 200) {
							items {
								salesRepId
								salesRepNumber
								name
								phoneNumber
								email
								inactiveDate
								sequence
							}
							pageInfo {
								hasNextPage
								hasPreviousPage
							}
						}
					}
				`;
			},
			update(data) {
				return data.salesReps.items;
			},
		},
		shippingMethods: {
			query() {
				return gql`
					query {
						shippingMethods(take: 500) {
							items {
								shippingMethodId
								shippingMethodName
							}
						}
					}
				`;
			},
			update: (data) => data.shippingMethods.items,
		},
		paymentTerms: {
			query() {
				return gql`
					query {
						paymentTerms(take: 500) {
							items {
								paymentTermsId
								paymentTermsName
							}
						}
					}
				`;
			},
			update: (data) => data.paymentTerms.items,
		},
		processTypes: {
			query() {
				return gql`
					query {
						processTypes(take: 500) {
							items {
								processTypeId: id
								name
								description
								requireAttaching
								includeParent
								sequence
							}
						}
					}
				`;
			},
			update(data) {
				return data.processTypes.items;
			},
		},
		letterPositions: {
			query() {
				return gql`
					query {
						letterPosition(take: 500) {
							items {
								letterPositionId
								code
								description
							}
						}
					}
				`;
			},
			update: (data) => data.letterPosition.items,
		},
	},
	methods: {
		getItemPrice,
		renderPrice,

		closePrintModal() {
			// Log performance metrics when closing the print modal
			if (this.sessionCache && !this.isPrinting) {
				const metrics = this.sessionCache.getMetrics();
				console.log('[PickTicketPrint] Closing print modal - Session metrics:', metrics);
			}
			this.showPrintModal = false;
		},

		formatDate(date) {
			if (!date) return "";

			date = date.substring(0, 10);
			const [year, month, day] = date.split("-");
			return `${month}/${day}/${year}`;
		},

		getCurrentDate() {
			// Use Central Time (America/Chicago) for consistent timestamps - Issue #1123
			const now = new Date();
			return now.toLocaleDateString('en-US', {
				timeZone: 'America/Chicago',
				month: 'numeric',
				day: 'numeric',
				year: '2-digit'
			});
		},
		getCurrentTime() {
			// Use Central Time (America/Chicago) for consistent timestamps - Issue #1123
			const now = new Date();
			return now.toLocaleTimeString('en-US', {
				timeZone: 'America/Chicago',
				hour: 'numeric',
				minute: '2-digit',
				hour12: true
			}).toLowerCase();
		},

		// Extract initials from a name string - Issue #1123
		extractInitials(nameOrInitials) {
			if (!nameOrInitials) return '';
			if (nameOrInitials.length <= 3) return nameOrInitials.toUpperCase();
			const parts = nameOrInitials.trim().split(/\s+/);
			if (parts.length >= 2) {
				return (parts[0][0] + parts[1][0]).toUpperCase();
			}
			return nameOrInitials.substring(0, 2).toUpperCase();
		},

		renderSalesRep(salesRepId, key) {
			let repById = this.salesReps ? this.salesReps.find((r) => r.salesRepId == salesRepId) : null;
			if (repById) {
				if (key === "name") {
					return repById.name;
				}
				if (key === "email") {
					return repById.email;
				}
				if (key === "phoneNumber") {
					return repById.phoneNumber;
				}
			} else {
				return null;
			}
		},

		async renderBin(itemId, sizeSelections) {
			let res = await this.$apollo.query({
				query: gql`
					query GetAnyInventoryItemById {
						anyInventoryItemById(id: ${itemId}) {
							inventoryItemId
							styleCode
							description
							stockItems
							sizeChart {
								sizes {
									sizeId
									name
									inventoryInfo {
										binNumber
										onHand
										committed
									}
								}
							}
							inventoryInfo {
								binNumber
								onHand
								committed
							}
						}
					}
				`,
				fetchPolicy: "no-cache",
			});

			let item = res.data.anyInventoryItemById;
			if (item && item.stockItems) {
				// If binNumber is present at the top level, return it
				if (item?.inventoryInfo?.binNumber) {
					return item.inventoryInfo.binNumber;
				}

				// Use a Set to ensure distinct bin numbers
				const bins = new Set();

				if (item && item.sizeChart && item.sizeChart.sizes) {
					sizeSelections.forEach((selection) => {
						const sizeInfo = item.sizeChart.sizes.find((size) => size.sizeId === selection.sizeId);
						if (sizeInfo && sizeInfo.inventoryInfo && sizeInfo.inventoryInfo.binNumber) {
							bins.add(sizeInfo.inventoryInfo.binNumber);
						}
					});
				}

				if (bins.size === 0) {
					// Check the size of the set
					res = await this.$apollo.query({
						query: gql`
						query GetSubItem {
							subItemById(id: ${itemId}) {
								inventoryItemId
								styleCode
								description
								inventoryInfo {
									binNumber
									onHand
									committed
								}
							}
						}
					`,
						fetchPolicy: "no-cache",
					});

					if (res.data.subItemById && res.data.subItemById.inventoryInfo) {
						bins.add(res.data.subItemById.inventoryInfo.binNumber);
					}
				}

				return [...bins].join("\n");
			}

			return "";
		},

		renderPaymentMethod(paymentMethodId) {
			let paymentMethodById = this.printInfo.paymentMethods
				? this.printInfo.paymentMethods.find((s) => s.paymentMethodId == paymentMethodId)
				: null;
			return paymentMethodById ? paymentMethodById.paymentMethodName.toUpperCase() : null;
		},

		renderShippingMethod(shippingMethodId) {
			let shippingById = this.shippingMethods
				? this.shippingMethods.find((s) => s.shippingMethodId == shippingMethodId)
				: null;
			return shippingById ? shippingById.shippingMethodName : null;
		},

		renderPaymentTerms(paymentTermsId) {
			let paymentById = this.paymentTerms
				? this.paymentTerms.find((s) => s.paymentTermsId == paymentTermsId)
				: null;
			return paymentById ? paymentById.paymentTermsName.toUpperCase() : null;
		},

		renderColorOption(color, colorOptions = []) {
			// Build a complete map of colorId -> color info from colorOptions
			let colorObj = {};
			colorOptions.forEach((option) => {
				const colorDescription = option.description;
				const colorOption = option.name;
				option.colorPalettes?.forEach((colorPalette) => {
					colorPalette.colors?.forEach((colorDetail) => {
						colorObj[colorDetail.colorId] = { ...colorDetail, colorDescription, colorOption };
					});
				});
			});

			if (color.colorOptionId) {
				let optionById = colorOptions.find((c) => c.colorOptionId == color.colorOptionId);
				if (optionById) {
					// Look up the color description from the colorObj map using colorId
					const colorDetail = colorObj[color.colorId];
					const colorName = colorDetail?.description || color.description || color.colorName || color.text;

					return optionById.description
						? `${optionById.name}:${optionById.description}:${colorName}`
						: `${optionById.name}:${colorName}`;
				}
				// Fallback: use flattened properties from the color selection itself
				// (ChildItemInfo items have colorOption/colorDescription but no colorOptions array)
				if (color.colorOption) {
					const colorName = color.colorName || color.text || '';
					return color.colorDescription
						? `${color.colorOption}:${color.colorDescription}:${colorName}`
						: colorName ? `${color.colorOption}:${colorName}` : color.colorOption;
				}
				return null;
			} else {
				if (colorObj[color.colorId]) {
					return `${colorObj[color.colorId].colorOption}:${
						colorObj[color.colorId].colorDescription
					}:${colorObj[color.colorId].description}`;
				}
				// Fallback: use flattened properties
				if (color.colorOption) {
					const colorName = color.description || color.colorName || color.text || '';
					return color.colorDescription
						? `${color.colorOption}:${color.colorDescription}:${colorName}`
						: colorName ? `${color.colorOption}:${colorName}` : color.colorOption;
				}
				return "";
			}
		},

		sortedColors(colorSelections) {
			if (!colorSelections) return [];
			return [...colorSelections].sort((a, b) => (a.colorOptionPosition ?? 0) - (b.colorOptionPosition ?? 0));
		},

		buildSizeSequenceMap(sizeChart) {
			const idMap = new Map();
			const nameMap = new Map();
			if (!sizeChart || !sizeChart.sizes) {
				return { idMap, nameMap };
			}

			sizeChart.sizes.forEach(size => {
				const seq = size.sortOrder ?? size.sequence ?? 999;
				idMap.set(size.sizeId, seq);
				if (size.name) nameMap.set(size.name, seq);
			});

			return { idMap, nameMap };
		},

		mergeAndSortAllSizes(lineItem) {
			if (!lineItem) return [];

			// Build sequence lookup from size chart
			const { idMap, nameMap } = this.buildSizeSequenceMap(lineItem.sizeChart);

			// Mark normal vs special sizes and add sequence
			const normalSizes = (lineItem.sizeSelections || []).map(size => ({
				...size,
				isSpecial: false,
				sequence: idMap.get(size.sizeId) || 998
			}));

			const specialSizes = (lineItem.specialSizeSelections || []).map(size => ({
				...size,
				isSpecial: true,
				sequence: nameMap.get(size.name || size.size) ?? 999
			}));

			// Merge arrays
			const allSizes = [...normalSizes, ...specialSizes];

			// Filter out zero quantities
			const validSizes = allSizes.filter(size =>
				size.quantity !== 0 && size.quantity !== ""
			);

			// Sort by:
			// 1. Sequence (ascending) - respects size chart order
			// 2. Length (ascending, numeric) - within same size
			validSizes.sort((a, b) => {
				// Primary sort: sequence
				if (a.sequence !== b.sequence) {
					return a.sequence - b.sequence;
				}

				// Secondary sort: length (numeric)
				const lengthA = a.length ? parseInt(a.length, 10) : 0;
				const lengthB = b.length ? parseInt(b.length, 10) : 0;
				return lengthA - lengthB;
			});

			// Format sizes with proper trimming and no space before slash
			return validSizes.map(size => {
				const sizeName = size.name || size.size || '';
				const length = size.length ? `/${size.length}` : '';
				return `${size.quantity}-${sizeName}${length}`.trim();
			});
		},

		renderSizes(sizeSelections, isSpecialSize) {
			let listOfSizes = [];

			sizeSelections.forEach((size) => {
				const sizeString = `${size.quantity}-${size.name || size.size} ${
					size.length ? `/${size.length}` : ""
				}`;

				if (size.quantity !== 0 && size.quantity !== "") {
					// special sizes should end with "
					if (!isSpecialSize) {
						listOfSizes.push(sizeString.trim());
					} else {
						listOfSizes.push(sizeString.trim() + '"');
					}
				}
			});

			return listOfSizes.join(", ");
		},

	renderPendingPOs(purchaseOrders) {
		// Use getFilteredWorkToBeDone and extract unique PO numbers
		// This ensures the PO list matches the "Work to be done" section
		if (!purchaseOrders || purchaseOrders.length === 0) {
			return [];
		}

		// Get all pending work items (already sorted correctly)
		const pendingWork = this.getFilteredWorkToBeDone(purchaseOrders[0]);

		// Extract unique PO numbers with their metadata
		const uniquePOs = pendingWork.map(work => ({
			number: work.purchaseOrderNumber,
			lineItemId: work.lineItemId,
			isAttaching: work.isAttaching
		}));

		return uniquePOs;
	},

	getOrderedItemsAboveDivider(po, pickTicket) {
		const items = [];

		// 1. Main items and their stock children from purchaseOrder.items
		for (const item of po.items || []) {
			items.push({ ...item, _type: 'item', _pickTicket: pickTicket });

			// Stock children: ReadyToShip children without received POs
			if (item.children) {
				item.children
					.filter(c => c.status === 'ReadyToShip' && !this.hasReceivedPurchaseOrder(c))
					.forEach(child => {
						items.push({ ...child, _type: 'stockChild', _parentItem: item });
					});
			}
		}

		// 2. Received sub-items from sibling/child POs (getFilteredSubItems)
		const subItems = this.getFilteredSubItems(po) || [];
		for (const subItem of subItems) {
			items.push({ ...subItem, _type: 'subItem' });
		}

		// 3. Sort: lineItemId ascending, then non-attaching before attaching
		items.sort((a, b) => {
			const aId = a.lineItemId || 0;
			const bId = b.lineItemId || 0;
			if (aId !== bId) return aId - bId;

			// Same lineItemId: non-attaching first, attaching last
			const aAttach = a.isAttaching ? 1 : 0;
			const bAttach = b.isAttaching ? 1 : 0;
			if (aAttach !== bAttach) return aAttach - bAttach;

			// Stock children after their parent item
			const aType = a._type === 'stockChild' ? 1 : 0;
			const bType = b._type === 'stockChild' ? 1 : 0;
			return aType - bType;
		});

		return items;
	},

	getProcessingTotalQty(pickTicket) {
		// Sum all items above "Work to be done", excluding ATTACH items
		const aboveItems = this.getOrderedItemsAboveDivider(pickTicket.purchaseOrder, pickTicket);
		return aboveItems
			.filter(item => !item.isAttaching)
			.reduce((total, item) => total + (Number(item.quantity) || 0), 0) || 0;
	},

	// Resolve PO-specific data for an item rendered in purchaseOrder.items.
	// Items from computedItems have a purchaseOrders array (empty for stocked infinite items).
	// Items from PO-owned data don't have the property at all and should fall back to the main PO.
	getItemReceivedItems(item, pickTicket) {
		if (item.purchaseOrders === undefined) {
			// PO-owned item without its own purchaseOrders property — use main PO
			return pickTicket.purchaseOrder.receivedItems;
		}
		// Item has purchaseOrders property: use its own PO data (null if empty/stocked infinite)
		return item.purchaseOrders?.[0]?.receivedItems;
	},

	getItemIsAttaching(item, pickTicket) {
		if (item.purchaseOrders === undefined) {
			return pickTicket.purchaseOrder.isAttaching;
		}
		return item.purchaseOrders?.[0]?.isAttaching ?? false;
	},

	getItemPurchaseOrderNumber(item, pickTicket) {
		if (item.purchaseOrders === undefined) {
			return pickTicket?.purchaseOrder?.orderNumber;
		}
		return item.purchaseOrders?.[0]?.purchaseOrderNumber;
	},

		renderItemTotal(item) {
			let formatter = new Intl.NumberFormat("en-US", {
				style: "currency",
				currency: "USD",
			});

			let vendorCost = item.vendorCost ? parseFloat(item.vendorCost) : 0;
			let itemCost = item.cost ? parseFloat(item.cost) : 0;
			let quantity = item.quantity ? parseFloat(item.quantity) : 0;

			let itemTotal = 0;

			itemTotal += (itemCost + vendorCost) * quantity;
			return formatter.format(itemTotal.toFixed(2));
		},

		shouldRenderParentItem(item) {
			if (item.itemOrdered && item.itemOrdered.processTypeId) {
				const processType = this.processTypes.find(
					(pt) => pt.processTypeId === item.itemOrdered.processTypeId
				);

				if (processType && processType.processTypeId) {
					return (
						item.parentItem?.parentPoId &&
						(processType.includeParent || processType.processTypeId === 3)
					);
				}
			}

			return false;
		},

		formatMostRecentReceivedDate(receivedItems) {
			if (!receivedItems || receivedItems.length === 0) {
				return "";
			}

			const mostRecentDate = receivedItems.reduce((latest, item) => {
				const currentDate = new Date(item.receivedDate);
				return currentDate > latest ? currentDate : latest;
			}, new Date(0));

			return this.formatDate(mostRecentDate.toISOString());
		},

		async generatePrintDoc() {
			for (let pickTicket of this.pickTickets) {
				const barcodeRef = this.$refs[`barcode-${pickTicket.pickTicketId}`];
				const barcodeSvg = barcodeRef && barcodeRef.length > 0 ? barcodeRef[0] : null;
				if (barcodeSvg) {
					JsBarcode(barcodeSvg, `*${pickTicket.pickTicketId}*`, {
						format: "CODE128",
						lineColor: "#000",
						width: 2,
						height: 40,
						displayValue: true,
						fontSize: 12,
					});
				}

				const printElement = document.querySelector(`.print-${pickTicket.pickTicketId}`);
				if (!printElement || !printElement.parentElement) {
					console.error(`[PickTicketPrint] Could not find print element for pickTicket ${pickTicket.pickTicketId}`);
					continue;
				}
				let printHTML = printElement.parentElement.innerHTML;

				if (!this.skipPreview) {
					let printDoc = pickTicket.type?.toLowerCase() === "processing"
						? this.generateProcessingPickTicket(printHTML, pickTicket.pickTicketId)
						: this.generateNormalPickTicket(printHTML, pickTicket.pickTicketId);

					try {
						const response = await this.$http.post("api/document", printDoc, {
							headers: { "Content-Type": "text/html" },
						});
						const docId = response.data.docId;
						const pdfResponse = await this.$http.get(`/api/document/${docId}`, {
							responseType: 'blob',
						});
						const blobUrl = URL.createObjectURL(pdfResponse.data);
						this.$set(this.pdfUrls, pickTicket.pickTicketId, blobUrl + '#navpanes=0&view=FitH');
					} catch (err) {
						console.error(`Failed to generate PDF preview for PT ${pickTicket.pickTicketId}:`, err);
					}
				}
			}
		},

		generateNormalPickTicket(printHTML, pickTicketId) {
			/* eslint-disable */
			// Use local PagedJS - no CDN dependencies
			const pagedJsScript = pagedJSService.getPagedJSScriptTag({
				inline: false
			});

			return `<!DOCTYPE html>
					<html>
					<head>
						${pagedJsScript}
						<script>
							class Sanitize extends Paged.Handler
							{
								constructor(chunker, polisher, caller) {
									super(chunker, polisher, caller);
								}

								afterPageLayout(pageFragment, page) {
									const contentElements = document.querySelectorAll('.pagedjs_page_content');
									contentElements.forEach(element => {
										let style = element.getAttribute("style");
										if (style) {
											style = style.replace(/column-width:[^;]+;?/, '');
											element.setAttribute("style", style);
										}
									});
								}

								afterRendered(pages) {
									// Set completion flag for server-side PDF generation
									window.__pagedjs_complete = true;

									// Fix "Page X of 0" - counter(pages) is unreliable in running elements
									const totalPages = pages.length;
									document.querySelectorAll('.pagedjs_page').forEach((pageEl, index) => {
										const pageNumberEl = pageEl.querySelector('.page-number');
										if (pageNumberEl) {
											pageNumberEl.textContent = 'Page ' + (index + 1) + ' of ' + totalPages;
										}
									});

									// Notify parent window that PagedJS has finished rendering all pages
									if (window.parent && window.parent !== window) {
										window.parent.postMessage({
											type: 'pagedjs-complete',
											pickTicketId: ${pickTicketId},
											pageCount: pages.length
										}, '*');
									}
								}
							}
							Paged.registerHandlers(Sanitize);
						<\/script>
						<style type="text/css">
						*,::after,::before{box-sizing:border-box;margin:0;padding:0}
						body{counter-reset: page;overflow:hidden;overflow-y:scroll;-webkit-print-color-adjust: exact;print-color-adjust: exact;}
						@page{size:Letter;margin:0.4cm;margin-top:3cm;margin-bottom:1.2cm; @top-center{content:element(pageHeader)} @bottom-center{content:element(pageIdFooter)}}
						#print-header{counter-increment: page;}
						#print-header:after{content:" " counter(page);left:0;top:100%;white-space:nowrap;z-index:100;}
						.print-${pickTicketId}{height:100%;position:relative;background-color:#fff;line-height:14pt;font-family: Arial, Helvetica, "Nimbus Sans L", "Liberation Sans", sans-serif!important;width:100%}
						.barcode{display:flex;justify-content:flex-end}
						.print-wrapper{height:100%;display:flex;flex-direction:column}.print-heading{position:running(pageHeader);display:block;}
						.page-id-footer{position:running(pageIdFooter);font-family:Arial,sans-serif;font-size:9pt;color:#555;text-align:center;padding:4px 0}
						.page-id-footer .page-number::after{content:none}
						.print-heading p{font-size:12pt;font-family: Arial, Helvetica, "Nimbus Sans L", "Liberation Sans", sans-serif;margin-bottom:8px!important}
						.print-heading-logo{display:block;width:100%;text-align:center}
						.print-heading-logo img{max-width:70%;height:auto}
						.print-heading-type{display:inline-block;width:100%;padding:4px;margin-bottom:8px;text-align:center;font-size:14pt;background-color:#000;color:#fff}
						.print-heading-left{display:inline-block;width:25%;text-align:left;vertical-align:top}
						.print-heading-center{display:inline-block;width:50%;vertical-align:top}
						.print-heading-right{display:inline-block;font-family: Arial, Helvetica, "Nimbus Sans L", "Liberation Sans", sans-serif;width:25%;text-align:right;vertical-align:top}
						.print-info{display:flex;margin-bottom:8px;align-items:stretch;flex-wrap:wrap}.print-info-container-split{width:48%}
						.print-info-container-split:last-child{margin-left:4%}.print-info-container-split table{width:100%;height:100%;border-spacing:0px;font-size:10pt;border:1px solid #000}
						.print-info-container-split table thead tr{page-break-inside:avoid}
						.print-info-container-split table thead tr th{padding:4px;background-color:#000;color:#fff;text-align:center;font-weight:400}
						.print-info-container-split table tbody tr{page-break-inside:avoid}
						.print-info-container-split table tbody tr td{padding:5px;padding-left:15px}
						.print-info-container-split table tbody tr td p.addr-city-state{margin-bottom:20px!important}
						.print-info-container-full{display:block;width:100%}.print-info-container-full table{width:100%;border-spacing:0px;font-size:10pt;border:1px solid #000}
						.print-info-container-full table thead tr{page-break-inside:avoid}
						.print-info-container-full table thead tr th{padding:4px;background-color:#000;color:#fff;text-align:center;font-weight:400}
						.print-info-container-full table tbody tr{page-break-inside:avoid}
						.print-info-container-full table tbody tr td{padding:4px;text-align:center;border-right:1px solid #000}
						.print-info-container-full table tbody tr td:last-child{border-right:none}
						.print-items{display:block; margin-bottom: 16px;}.print-items-container{display:block;width:100%}
						.print-items-container table{width:100%;border-spacing:0px;border:1px solid #000}
						.print-items-container table thead tr{page-break-inside:avoid}
						.print-items-container table thead tr th{font-size:10pt;padding:4px 2px;background-color:#000;color:#fff;text-align:center;font-weight:400}
						.print-items-container table tbody tr{page-break-inside:avoid}
						.print-items-container table tbody tr td{font-size:9pt;vertical-align:top;padding:3px 2px;text-align:center;border-right:1px solid #000;line-height:15px}
						.print-items-container table tbody tr td:last-child{border-right:none}
						.print-items-container table tbody tr td:nth-child(1){width:50px}
						.print-items-container table tbody tr td:nth-child(2){width:10%;text-align:center}
						.print-items-container table tbody tr td:nth-child(3){width:16%;text-align:left}
						.print-items-container table tbody tr td:nth-child(4){text-align:left}
						.print-items-container table tbody tr td:nth-child(5){width:8%;text-align:center}
						.print-items-title{font-weight:700}.print-items-value{font-weight:700}
						.print-total-container {display:flex}
						.print-total-container table thead tr th{padding:8px;background-color:#000;color:#fff;text-align:center;font-weight:400}
						.print-total-table {min-width: 25%}
						.print-footer {margin-top: auto}
						.print-footer-table {min-width: 25%}
						.print-footer-container {display:flex;justify-content:space-between}
						.print-footer-table thead tr th{padding:8px;background-color:#000;color:#fff;text-align:center;font-weight:400;}
						.print-footer-left {display:flex;flex-direction:column-reverse}
						.print-on {font-size: small}
						.size-item{display:inline-block;white-space:pre}
						</style>
						<style type="text/css">


						.print-rep-prices-table {
							page-break-inside: avoid;
						}
						.print-table-price table{
							width: 100%;
							border-spacing: 0px;
							font-size: 11pt;
							border: 1px solid #DDD;
							min-width: 250px;
							page-break-inside: avoid;
						}
						.print-table-price-rowLabel {

							background-color: #CCC;
							color: #fff;
							font-weight: 400;
						}
						.print-table-price table tbody tr {
							page-break-inside: avoid;
						}
						.print-table-price tr {
							border: 1px solid #000;
						}
						.print-table-price td {
							padding: 4px;
							border: 1px solid #000;
						}

						.print-payments {
							margin-top: 8px;
						}
						.print-payments-table{
							width: 100%;
							border-spacing: 0px;
							font-size: 11pt;
							border: 1px solid #000;
							min-width: 250px;
						}
						.print-payments-table tr {
							border: 1px solid #000;
						}
						.print-payments-table td {
							padding: 4px;
							border: 1px solid #000;
						}
						.print-payments-table th {
							padding: 4px;
							background-color: black;
							color: white;
							border: 1px solid #000;
						}
						</style>
					</head>
					<body>
						${printHTML}
					</body>
                	</html>`;
		},

		generateProcessingPickTicket(printHTML, pickTicketId) {
			/* eslint-disable */
			// Use local PagedJS - no CDN dependencies
			const pagedJsScript = pagedJSService.getPagedJSScriptTag({
				inline: false
			});

			return `<!DOCTYPE html>
					<html>
					<head>
						${pagedJsScript}
						<script>
							class Sanitize extends Paged.Handler
							{
								constructor(chunker, polisher, caller) {
									super(chunker, polisher, caller);
								}

								afterPageLayout(pageFragment, page) {
									const contentElements = document.querySelectorAll('.pagedjs_page_content');
									contentElements.forEach(element => {
										let style = element.getAttribute("style");
										if (style) {
											style = style.replace(/column-width:[^;]+;?/, '');
											element.setAttribute("style", style);
										}
									});
								}

								afterRendered(pages) {
									// Set completion flag for server-side PDF generation
									window.__pagedjs_complete = true;

									// Fix "Page X of 0" - counter(pages) is unreliable in running elements
									const totalPages = pages.length;
									document.querySelectorAll('.pagedjs_page').forEach((pageEl, index) => {
										const pageNumberEl = pageEl.querySelector('.page-number');
										if (pageNumberEl) {
											pageNumberEl.textContent = 'Page ' + (index + 1) + ' of ' + totalPages;
										}
									});

									// Notify parent window that PagedJS has finished rendering all pages
									if (window.parent && window.parent !== window) {
										window.parent.postMessage({
											type: 'pagedjs-complete',
											pickTicketId: ${pickTicketId},
											pageCount: pages.length
										}, '*');
									}
								}
							}
							Paged.registerHandlers(Sanitize);
						<\/script>
						<style type="text/css">
						*,::after,::before{box-sizing:border-box;margin:0;padding:0}
						body{counter-reset: page;overflow:hidden;overflow-y:scroll;-webkit-print-color-adjust: exact;print-color-adjust: exact;}
						@page{size:Letter;margin:0.4cm;margin-top:3cm;margin-bottom:1.2cm; @top-center{content:element(pageHeader)} @bottom-center{content:element(pageIdFooter)}}
						#print-header{counter-increment: page;}
						#print-header:after{content:" " counter(page);left:0;top:100%;white-space:nowrap;z-index:100;}
						.print-${pickTicketId}{height:100%;position:relative;background-color:#fff;line-height:14pt;font-family: Arial, Helvetica, "Nimbus Sans L", "Liberation Sans", sans-serif!important;width:100%}
						.print-wrapper{height:100%;display:flex;flex-direction:column}.print-heading{position:running(pageHeader);display:block;}
						.page-id-footer{position:running(pageIdFooter);font-family:Arial,sans-serif;font-size:9pt;color:#555;text-align:center;padding:4px 0}
						.page-id-footer .page-number::after{content:none}
						.print-heading p{font-size:12pt;font-family: Arial, Helvetica, "Nimbus Sans L", "Liberation Sans", sans-serif;margin-bottom:8px!important}
						.print-heading-logo{display:block;width:100%;text-align:center}
						.print-heading-logo img{max-width:70%;height:auto}
						.print-heading-type{display:inline-block;width:100%;padding:4px;margin-bottom:8px;text-align:center;font-size:9pt;background-color:#000;color:#fff}
						.print-heading-left{display:inline-block;width:25%;text-align:left;vertical-align:top}
						.print-heading-center{display:inline-block;width:50%;vertical-align:top}
						.print-heading-right{display:inline-block;font-family: Arial, Helvetica, "Nimbus Sans L", "Liberation Sans", sans-serif;width:25%;text-align:right;vertical-align:top}
						.print-info{display:flex;margin-bottom:8px;justify-content:space-evenly;align-items:stretch;flex-wrap:wrap}
						.print-info-container-split{width:48%}
						.po-badge-container {display: flex;flex-wrap: wrap;gap: 5px;align-content: flex-start;}
						.po-badge {width: 48%;display: flex;justify-content: center;padding: 8px 16px;background-color: #000;color: #fff;font-size: 12px;box-sizing: border-box;}
						.print-items-received {font-size: 10px; color: gray; text-wrap: nowrap;}
						.print-info-container-split:last-child{margin-left:4%}.print-info-container-split table{width:100%;height:100%;border-spacing:0px;font-size:10pt;border:1px solid #000}
						.print-info-container-split table thead tr{page-break-inside:avoid}
						.print-info-container-split table thead tr th{padding:4px;background-color:#000;color:#fff;text-align:center;font-weight:400}
						.print-info-container-split table tbody tr{page-break-inside:avoid}
						.print-info-container-split table tbody tr td{padding:5px;padding-left:15px}
						.print-info-container-split table tbody tr td p.addr-city-state{margin-bottom:20px!important}
						.print-info-container-full{display:block;width:100%}.print-info-container-full table{width:100%;border-spacing:0px;font-size:10pt;border:1px solid #000}
						.print-info-container-full table thead tr{page-break-inside:avoid}
						.print-info-container-full table thead tr th{padding:4px;background-color:#000;color:#fff;text-align:center;font-weight:400}
						.print-info-container-full table tbody tr{page-break-inside:avoid}
						.print-info-container-full table tbody tr td{padding:4px;text-align:center;border-right:1px solid #000}
						.print-info-container-full table tbody tr td:last-child{border-right:none}
						.print-items{display:block; margin-bottom: 16px;}.print-items-container{display:block;width:100%}
						.print-items-received {font-size:10px;color: gray;text-wrap:nowrap;}
						.print-items-container table{width:100%;border-spacing:0px;border:1px solid #000}
						.print-items-container table thead tr{page-break-inside:avoid}
						.print-items-container table thead tr th{font-size:10pt;padding:4px 2px;background-color:#000;color:#fff;text-align:center;font-weight:400}
						.print-items-container table tbody tr{page-break-inside:avoid}
						.print-items-container table tbody tr td{font-size:9pt;vertical-align:top;padding:3px 2px;text-align:center;border-right:1px solid #000;line-height:15px}
						.print-items-container table tbody tr td:last-child{border-right:none}
						.print-items-container table tbody tr td:nth-child(1){width:50px}
						.print-items-container table tbody tr td:nth-child(2){width:10%;text-align:center}
						.print-items-container table tbody tr td:nth-child(3){width:16%;text-align:left}
						.print-items-container table tbody tr td:nth-child(4){text-align:left}
						.print-items-container table tbody tr td:nth-child(5){width:8%;text-align:center}
						.print-items-title{font-weight:700}.print-items-value{font-weight:700}
						.print-total-container {display:flex}
						.print-total-container table thead tr th{padding:8px;background-color:#000;color:#fff;text-align:center;font-weight:400}
						.print-total-table {min-width: 25%}
						.print-footer {margin-top: auto}
						.print-footer-table {min-width: 25%}
						.print-footer-container {display:flex;justify-content:space-between}
						.print-footer-table thead tr th{padding:8px;background-color:#000;color:#fff;text-align:center;font-weight:400;}
						.print-footer-left {display:flex;flex-direction:column-reverse}
						.print-on {font-size: small}
						.size-item{display:inline-block;white-space:pre}
						</style>
						<style type="text/css">


						.print-rep-prices-table {
							page-break-inside: avoid;
						}
						.print-table-price table{
							width: 100%;
							border-spacing: 0px;
							font-size: 11pt;
							border: 1px solid #DDD;
							min-width: 250px;
							page-break-inside: avoid;
						}
						.print-table-price-rowLabel {

							background-color: #CCC;
							color: #fff;
							font-weight: 400;
						}
						.print-table-price table tbody tr {
							page-break-inside: avoid;
						}
						.print-table-price tr {
							border: 1px solid #000;
						}
						.print-table-price td {
							padding: 4px;
							border: 1px solid #000;
						}

						.print-payments {
							margin-top: 8px;
						}
						.print-payments-table{
							width: 100%;
							border-spacing: 0px;
							font-size: 11pt;
							border: 1px solid #000;
							min-width: 250px;
						}
						.print-payments-table tr {
							border: 1px solid #000;
						}
						.print-payments-table td {
							padding: 4px;
							border: 1px solid #000;
						}
						.print-payments-table th {
							padding: 4px;
							background-color: black;
							color: white;
							border: 1px solid #000;
						}
						</style>
					</head>
					<body>
						${printHTML}
					</body>
                	</html>`;
		},

		onPdfIframeLoad(pickTicketId) {
			if (!this.pdfUrls[pickTicketId]) return;
			console.log(`[PickTicketPrint] PDF preview loaded for PT ${pickTicketId}`);
			this.pdfReadySet = new Set([...this.pdfReadySet, Number(pickTicketId)]);
			const expectedIds = this.pickTicketIds.map(id => Number(id));
			const allComplete = expectedIds.length > 0
				&& expectedIds.every(id => this.pdfReadySet.has(id));
			if (allComplete) {
				console.log('[PickTicketPrint] All PDF previews loaded');
				this.$emit('pagedjs-complete');
			}
		},

		async print() {
			this.isPrinting = true;
			this.printResult = {
				show: false,
				type: "success",
				message: "",
			};

			// Log performance metrics at start of printing
			if (this.sessionCache) {
				const metrics = this.sessionCache.getMetrics();
				console.log('[PickTicketPrint] Starting print operation - Current metrics:', metrics);
			}

			try {
				// Form validation
				if (!this.isFormValid) {
					if (!this.printerSelection) {
						this.printResult = {
							show: true,
							type: "error",
							message: "Please select a printer",
						};
					} else if (!this.copies || this.copies <= 0) {
						this.printResult = {
							show: true,
							type: "error",
							message: "Please enter a valid number of copies",
						};
					}
					this.isPrinting = false;
					return;
				}

				// For each pick ticket, create a document and send to printer
				for (let pickTicket of this.pickTickets) {
					// Get print HTML for this pick ticket
					const printHTML = document.querySelector(`.print-${pickTicket.pickTicketId}`)
						.parentElement.innerHTML;
					const printDoc =
						pickTicket.type?.toLowerCase() === "processing"
							? this.generateProcessingPickTicket(printHTML, pickTicket.pickTicketId)
							: this.generateNormalPickTicket(printHTML, pickTicket.pickTicketId);

					// Get document ID by submitting to the API
					const documentResponse = await this.$http.post("api/document", printDoc, {
						headers: {
							"Content-Type": "text/html",
						},
					});

					const documentId = documentResponse.data.docId;

					// Create print options
					const printOptions = {
						copies: parseInt(this.copies, 10),
						color: false,
						duplex: false,
						collate: true,
						paperSize: "letter",
					};

					// Add metadata for print job logging
					const metadata = {
						documentType: 3, // PickTicket = 3 (from enum)
						documentNumber: pickTicket.pickTicketId.toString(),
						pickTicketId: pickTicket.pickTicketId,
						salesOrderId: this.orderId,
						message: this.printMessage,
					};

					// Send the print job request
					const printResponse = await this.$http.post(
						`/api/print/document`,
						{
							documentId: documentId,
							printerId: this.printerSelection,
							options: printOptions,
							metadata: metadata,
						}
					);

					// Handle responses that might not have expected structure
					if (printResponse && printResponse.data) {
						this.printJobId = printResponse.data.jobId || "unknown";
					} else {
						this.printJobId = "unknown";
					}
				}

				// Show success message in both the alert and snackbar
				const printerName =
					this.printers.find((p) => p.printerId === this.printerSelection)?.text ||
					"selected printer";

				this.printResult = {
					show: true,
					type: "success",
					message: `Pick Ticket${
						this.pickTickets.length > 1 ? "s" : ""
					} successfully sent to ${printerName}`,
				};

				// Display snackbar notification
				this.snackbar = {
					show: true,
					color: "success",
					text: this.printResult.message,
					timeout: 5000,
				};

				// Log final performance metrics after successful print
				if (this.sessionCache) {
					const metrics = this.sessionCache.getMetrics();
					console.log('[PickTicketPrint] Print operation complete - Final performance metrics:', metrics);
					console.log(`[PickTicketPrint] Successfully printed ${this.pickTickets.length} pick tickets - Total API calls: ${metrics.apiCalls}, Cache hits: ${metrics.cacheHits}, Cache hit rate: ${metrics.cacheHitRate}, Session duration: ${(metrics.sessionDuration / 1000).toFixed(2)}s`);
				}

				// Only hide the modal after a short delay to allow users to see the success message
				setTimeout(() => {
					this.showPrintModal = false;
					this.isPrinting = false;
				}, 2000);
			} catch (error) {
				console.error("Error printing document:", error);

				// Handle different error types with a safe extraction of error message
				let errorMessage = "Unknown error occurred";
				try {
					if (error.response && typeof error.response.data === "string") {
						errorMessage = error.response.data;
					} else if (error.message) {
						errorMessage = error.message;
					}
				} catch (e) {
					console.error("Error extracting error message:", e);
				}

				this.printResult = {
					show: true,
					type: "error",
					message: `Print failed: ${errorMessage}`,
				};

				// Display snackbar notification
				this.snackbar = {
					show: true,
					color: "error",
					text: this.printResult.message,
					timeout: 5000,
				};

				this.isPrinting = false;
			}
		},

		formatNewLines(text) {
			if (!text) return "";
			return text.replace(/\n/g, "<br/>").replace(/\t/g, "&emsp;");
		},

		async download() {
			// Download print documents for all pick tickets
			if (!this.pickTickets || this.pickTickets.length === 0) {
				console.error("No pick tickets available to download");
				return;
			}

			this.isDownloading = true;

			try {
				// If there's only one pick ticket, download it directly
				// If there are multiple, we need to handle them appropriately
				if (this.pickTickets.length === 1) {
					// Single pick ticket - download directly
					const pickTicket = this.pickTickets[0];
					await this.downloadSinglePickTicket(pickTicket);
				} else {
					// Multiple pick tickets - combine into one document or download separately
					// For now, let's download the first one and show a message for multiple
					// In the future, this could be enhanced to create a combined PDF or zip file
					console.log(`Downloading ${this.pickTickets.length} pick tickets...`);

					// Download each pick ticket
					for (const pickTicket of this.pickTickets) {
						await this.downloadSinglePickTicket(pickTicket);
						// Add a small delay between downloads to avoid overwhelming the browser
						await new Promise(resolve => setTimeout(resolve, 500));
					}
				}

				// Show success notification
				this.snackbar = {
					show: true,
					message: `Pick ticket${this.pickTickets.length > 1 ? 's' : ''} downloaded successfully`,
					color: 'success',
				};
			} catch (error) {
				console.error("Error downloading pick tickets:", error);
				// Show error notification
				this.snackbar = {
					show: true,
					message: "Failed to download pick ticket(s). Please try again.",
					color: 'error',
				};
			} finally {
				this.isDownloading = false;
			}
		},

		async downloadSinglePickTicket(pickTicket) {
			// Simply generate a fresh document for download
			// We cannot reliably get the processed content from the iframe due to cross-origin restrictions
			// and the fact that srcdoc returns the original HTML, not the processed DOM

			console.log(`Generating download for pick ticket ${pickTicket.pickTicketId}...`);

			// Get the HTML for the specific pick ticket
			let printHTML = '';
			const ticketElement = document.querySelector(`.print-${pickTicket.pickTicketId}`);
			if (ticketElement) {
				printHTML = ticketElement.parentElement.innerHTML;
			} else {
				console.error(`Could not find print element for pick ticket ${pickTicket.pickTicketId}`);
				return;
			}

			// Generate the appropriate print document based on type
			let printDoc;
			if (pickTicket.type?.toLowerCase() === 'processing') {
				printDoc = this.generateProcessingPickTicket(printHTML, pickTicket.pickTicketId);
			} else {
				printDoc = this.generateNormalPickTicket(printHTML, pickTicket.pickTicketId);
			}

			// Post the document to the API to get a document ID
			const response = await this.$http.post("api/document", printDoc, {
				headers: {
					"Content-Type": "text/html",
				},
			});

			const documentId = response.data.docId;

			// Open the download URL with metadata in query parameters for better filename
			const downloadUrl = `/api/document/${documentId}?type=pick-ticket&id=${pickTicket.pickTicketId}`;
			window.open(downloadUrl);

			console.log(`Downloaded pick ticket #${pickTicket.pickTicketId}`);
		},

		getLineNumber(lineItemId) {
			let lineItem = this.lineItems.find((li) => li.lineItemId === lineItemId);
			return lineItem ? lineItem.lineNumber : "";
		},

		/**
		 * Calculate bin for a line item based on size selections
		 * Matches legacy renderBin logic
		 */
		calculateBin(lineItem) {
			const item = lineItem.inventoryItem;
			if (!item) return lineItem.bin || '';

			// Priority 1: Item-level bin (for non-stocked items or items with a general bin)
			if (item.inventoryInfo && item.inventoryInfo.binNumber) {
				return item.inventoryInfo.binNumber;
			}

			// Priority 2: Size-specific bins (for stocked items with size selections)
			if (item.stockItems && lineItem.sizeSelections && lineItem.sizeSelections.length > 0) {
				const bins = new Set();

				if (item.sizeChart && item.sizeChart.sizes) {
					lineItem.sizeSelections.forEach(selection => {
						const sizeInfo = item.sizeChart.sizes.find(size => size.sizeId === selection.sizeId);
						if (sizeInfo && sizeInfo.inventoryInfo && sizeInfo.inventoryInfo.binNumber) {
							bins.add(sizeInfo.inventoryInfo.binNumber);
						}
					});
				}

				if (bins.size > 0) {
					return [...bins].join('\n');
				}
			}

			// Priority 3: Fallback to lineItem.bin from backend
			return lineItem.bin || '';
		},

		shouldRenderSubItem(item) {
			let includeWithParentPoResult = false;
			let sysCatId =
				(item.itemOrdered?.systemCategoryId ?? 0) > 0
					? item.itemOrdered.systemCategoryId
					: item.systemCategoryId;
			let systemCategory = this.$systemCategories.getSystemCategory(sysCatId);

			if (systemCategory) {
				includeWithParentPoResult = systemCategory.includeWithParentPO;
			}

			return includeWithParentPoResult;
		},

		getFilteredSubItems(po) {
			// Data structures vary:
			// Case 1: po.childItems[] has purchaseOrderNumber, orderStatus at PO level
			// Case 2: po.items[].childItems[].purchaseOrders[] has PO data with orderStatus, receivedItems
			// Case 3: po.items[].children[].purchaseOrders[] has PO data
			let allReceivedItems = [];
			let seenPOs = new Set();

			// Get parent item data
			const parentItem = po?.items?.[0];
			const itemChildItems = parentItem?.childItems || [];
			const itemChildren = parentItem?.children || [];

			// Resolve the parent garment's system category for "Attach X to Y" display
			const parentGarment = (po?.childItems || []).find(c => c.isParentItem);
			const parentGarmentSystemCategoryId = parentGarment?.inventoryItem?.systemCategoryId
				|| parentItem?.systemCategoryId
				|| parentItem?.inventoryItem?.systemCategoryId
				|| 0;

			// Build set of line item IDs already on this pick ticket — exclude from sub-items list
			const pickTicketLineItemIds = new Set(
				(po?.items || []).map(item => item.lineItemId).filter(Boolean)
			);

			// Source 1: po.childItems[] - PO level data (when available)
			const poChildItems = (po?.childItems || []).filter(c => !pickTicketLineItemIds.has(c.lineItemId));
			const poAttachItems = po?.attachItems || [];

			// Process po.childItems if they exist
			poChildItems.forEach(poChild => {
				if (poChild.orderStatus === 'Received' && poChild.purchaseOrderNumber && !seenPOs.has(poChild.purchaseOrderNumber)) {
					seenPOs.add(poChild.purchaseOrderNumber);
					const matchingItemChild = itemChildItems.find(ic => ic.lineItemId === poChild.lineItemId);
					const matchingChild = itemChildren.find(c => c.lineItemId === poChild.lineItemId);
					const detailSource = matchingItemChild || matchingChild;

					let receivedItems = [];
					if (detailSource?.purchaseOrders) {
						const matchingPO = detailSource.purchaseOrders.find(p => p.purchaseOrderNumber === poChild.purchaseOrderNumber);
						receivedItems = matchingPO?.receivedItems || [];
					}

					allReceivedItems.push({
						// Line item data as base — has full detail (colorOptions, etc.)
						...detailSource,
						// PO-specific fields only (don't spread poChild — it overrides inventoryItem)
						purchaseOrderNumber: poChild.purchaseOrderNumber,
						orderNumber: poChild.purchaseOrderNumber,
						orderStatus: 'Received',
						isAttaching: poChild.isAttaching || false,
						lineItemId: poChild.lineItemId || detailSource?.lineItemId,
						systemCategoryId: detailSource?.systemCategoryId || detailSource?.inventoryItem?.systemCategoryId || poChild.inventoryItem?.systemCategoryId || 0,
						receivedItems: receivedItems,
						// Fallback to PO data only when line item data is missing
						colorSelections: detailSource?.colorSelections || poChild.colorSelections || [],
						freeTextSelections: detailSource?.freeTextSelections || poChild.freeTextSelections || [],
						quantity: detailSource?.quantity ?? poChild.quantity,
						braidPosition: detailSource?.braidPosition ?? poChild.braidPosition,
						note: detailSource?.note ?? poChild.note,
						lettering: detailSource?.lettering ?? poChild.lettering,
						matchPreviousPoNumber: detailSource?.matchPreviousPoNumber ?? poChild.matchPreviousPoNumber,
						itemOrdered: detailSource?.itemOrdered || poChild.inventoryItem || null,
						sizeSelections: (detailSource?.sizeSelections || poChild.sizeSelections || []).map(s => ({
							...s, name: s.name || s.sizeName || ''
						})),
						specialSizeSelections: detailSource?.specialSizeSelections || poChild.specialSizeSelections || []
					});
				}
			});

			// Process po.attachItems if they exist
			poAttachItems.forEach(poAttach => {
				if (poAttach.orderStatus === 'Received' && poAttach.purchaseOrderNumber && !seenPOs.has(poAttach.purchaseOrderNumber)) {
					seenPOs.add(poAttach.purchaseOrderNumber);
					const matchingChild = itemChildren.find(c =>
						c.purchaseOrders?.some(p => p.purchaseOrderNumber === poAttach.purchaseOrderNumber)
					);
					const matchingItemChild = itemChildItems.find(ic =>
						ic.purchaseOrders?.some(p => p.purchaseOrderNumber === poAttach.purchaseOrderNumber)
					);
					const detailSource = matchingChild || matchingItemChild;

					let receivedItems = [];
					if (detailSource?.purchaseOrders) {
						const matchingPO = detailSource.purchaseOrders.find(p => p.purchaseOrderNumber === poAttach.purchaseOrderNumber);
						receivedItems = matchingPO?.receivedItems || [];
					}

					allReceivedItems.push({
						...detailSource,
						// PO-specific fields only
						purchaseOrderNumber: poAttach.purchaseOrderNumber,
						orderNumber: poAttach.purchaseOrderNumber,
						orderStatus: 'Received',
						isAttaching: true,
						receivedItems: receivedItems,
						colorSelections: detailSource?.colorSelections || [],
						freeTextSelections: detailSource?.freeTextSelections || []
					});
				}
			});

			// Source 2: items[].childItems[].purchaseOrders[] - check each PO for received status
			itemChildItems.forEach(childItem => {
				const purchaseOrders = childItem.purchaseOrders || [];
				purchaseOrders.forEach(childPO => {
					if (childPO.orderStatus === 'Received' && childPO.purchaseOrderNumber && !seenPOs.has(childPO.purchaseOrderNumber)) {
						seenPOs.add(childPO.purchaseOrderNumber);
						const matchingChild = itemChildren.find(c => c.lineItemId === childItem.lineItemId);
						const detailSource = matchingChild || childItem;

						allReceivedItems.push({
							...detailSource,
							// PO-specific fields only
							purchaseOrderNumber: childPO.purchaseOrderNumber,
							orderNumber: childPO.purchaseOrderNumber,
							orderStatus: 'Received',
							isAttaching: childPO.isAttaching || false,
							receivedItems: childPO.receivedItems || [],
							colorSelections: detailSource.colorSelections || [],
							freeTextSelections: detailSource.freeTextSelections || []
						});
					}
				});
			});

			// Source 3: items[].children[].purchaseOrders[] - also check here
			itemChildren.forEach(child => {
				const purchaseOrders = child.purchaseOrders || [];
				purchaseOrders.forEach(childPO => {
					if (childPO.orderStatus === 'Received' && childPO.purchaseOrderNumber && !seenPOs.has(childPO.purchaseOrderNumber)) {
						seenPOs.add(childPO.purchaseOrderNumber);

						allReceivedItems.push({
							// Line item data as base (child has full GraphQL data)
							...child,
							// PO-specific fields only
							purchaseOrderNumber: childPO.purchaseOrderNumber,
							orderNumber: childPO.purchaseOrderNumber,
							orderStatus: 'Received',
							isAttaching: childPO.isAttaching || false,
							receivedItems: childPO.receivedItems || [],
							colorSelections: child.colorSelections || [],
							freeTextSelections: child.freeTextSelections || []
						});
					}
				});
			});

			// Source 4: items[].purchaseOrders[] - check the main items' own attaching POs for received status
			(po?.items || []).forEach(item => {
				const purchaseOrders = item.purchaseOrders || [];
				purchaseOrders.forEach(itemPO => {
					if (itemPO.isAttaching && itemPO.orderStatus === 'Received' && itemPO.purchaseOrderNumber && !seenPOs.has(itemPO.purchaseOrderNumber)) {
						seenPOs.add(itemPO.purchaseOrderNumber);

						// Resolve parent garment's system category from the PO's parentItem/childItems
						const parentChild = (itemPO.childItems || []).find(
							c => c.isParentItem || c.lineItemId === itemPO.parentItem?.lineItemId
						);
						const parentSystemCategoryId = parentChild?.inventoryItem?.systemCategoryId || 0;

						allReceivedItems.push({
							// Line item detail from computed item
							inventoryItem: item.inventoryItem || null,
							colorOptions: item.inventoryItem?.colorOptions || item.colorOptions || [],
							// PO-specific fields
							purchaseOrderNumber: itemPO.purchaseOrderNumber,
							orderNumber: itemPO.purchaseOrderNumber,
							orderStatus: 'Received',
							isAttaching: true,
							receivedItems: itemPO.receivedItems || [],
							itemOrdered: item.itemOrdered || item.inventoryItem || null,
							colorSelections: item.colorSelections || [],
							freeTextSelections: item.freeTextSelections || [],
							quantity: item.quantity,
							lineItemId: item.lineItemId,
							systemCategoryId: item.systemCategoryId || item.itemOrdered?.systemCategoryId || 0,
							parentSystemCategoryId: parentSystemCategoryId,
							description: item.description || item.itemOrdered?.description || '',
							lettering: item.lettering || null,
							note: item.note || null,
							braidPosition: item.braidPosition || null,
							matchPreviousPoNumber: item.matchPreviousPoNumber || null,
							sizeSelections: item.sizeSelections || [],
							specialSizeSelections: item.specialSizeSelections || [],
						});
					}
				});
			});

			// Ensure all attaching entries have parentSystemCategoryId for "Attach X to Y" display
			allReceivedItems.forEach(item => {
				if (item.isAttaching && !item.parentSystemCategoryId) {
					item.parentSystemCategoryId = parentGarmentSystemCategoryId;
				}
			});

			return allReceivedItems.sort((a, b) => {
				return (a.lineItemId || 0) - (b.lineItemId || 0);
			});
		},

	getFilteredWorkToBeDone(po) {
		// Data structures vary (mirrors getFilteredSubItems but for non-received POs):
		// Case 1: po.childItems[] has purchaseOrderNumber, orderStatus at PO level
		// Case 2: po.items[].childItems[].purchaseOrders[] has PO data with orderStatus
		// Case 3: po.items[].children[].purchaseOrders[] has PO data
		let pendingWork = [];
		let seenPOs = new Set();

		// Get parent item data
		const parentItem = po?.items?.[0];
		const itemChildItems = parentItem?.childItems || [];
		const itemChildren = parentItem?.children || [];

		// Resolve the parent garment's system category for "Attach X to Y" display
		const parentGarment = (po?.childItems || []).find(c => c.isParentItem);
		const parentGarmentSystemCategoryId = parentGarment?.inventoryItem?.systemCategoryId
			|| parentItem?.systemCategoryId
			|| parentItem?.inventoryItem?.systemCategoryId
			|| 0;

		// Build set of line item IDs already on this pick ticket — exclude from "Work to be done"
		const pickTicketLineItemIds = new Set(
			(po?.items || []).map(item => item.lineItemId).filter(Boolean)
		);

		// Source 1: po.childItems[] - PO level data (when available)
		const poChildItems = (po?.childItems || []).filter(c => !pickTicketLineItemIds.has(c.lineItemId));
		const poAttachItems = po?.attachItems || [];

		// Process po.childItems if they exist (Pattern 1)
		poChildItems.forEach(poChild => {
			if (poChild.orderStatus !== 'Received' && poChild.purchaseOrderNumber && !seenPOs.has(poChild.purchaseOrderNumber)) {
				seenPOs.add(poChild.purchaseOrderNumber);
				const matchingItemChild = itemChildItems.find(ic => ic.lineItemId === poChild.lineItemId);
				const matchingChild = itemChildren.find(c => c.lineItemId === poChild.lineItemId);
				const detailSource = matchingItemChild || matchingChild;

				pendingWork.push({
					// Line item data as base
					...detailSource,
					// PO-specific fields only (don't spread poChild — it overrides inventoryItem)
					purchaseOrderNumber: poChild.purchaseOrderNumber,
					orderNumber: poChild.purchaseOrderNumber,
					orderStatus: poChild.orderStatus || 'OnOrder',
					isAttaching: poChild.isAttaching || false,
					lineItemId: poChild.lineItemId || detailSource?.lineItemId,
					systemCategoryId: detailSource?.systemCategoryId || detailSource?.inventoryItem?.systemCategoryId || poChild.inventoryItem?.systemCategoryId || 0,
					colorSelections: detailSource?.colorSelections || poChild.colorSelections || [],
					freeTextSelections: detailSource?.freeTextSelections || poChild.freeTextSelections || [],
					inventoryItem: detailSource?.inventoryItem || null,
					colorOptions: detailSource?.inventoryItem?.colorOptions || detailSource?.colorOptions || [],
					itemOrdered: detailSource?.itemOrdered || poChild.inventoryItem || null,
					quantity: detailSource?.quantity ?? poChild.quantity,
					braidPosition: detailSource?.braidPosition ?? poChild.braidPosition,
					note: detailSource?.note ?? poChild.note,
					lettering: detailSource?.lettering ?? poChild.lettering,
					matchPreviousPoNumber: detailSource?.matchPreviousPoNumber ?? poChild.matchPreviousPoNumber,
					sizeSelections: (detailSource?.sizeSelections || poChild.sizeSelections || []).map(s => ({
						...s, name: s.name || s.sizeName || ''
					})),
					specialSizeSelections: detailSource?.specialSizeSelections || poChild.specialSizeSelections || []
				});
			}
		});

		// Process po.attachItems if they exist (Pattern 1)
		poAttachItems.forEach(poAttach => {
			if (poAttach.orderStatus !== 'Received' && poAttach.purchaseOrderNumber && !seenPOs.has(poAttach.purchaseOrderNumber)) {
				seenPOs.add(poAttach.purchaseOrderNumber);
				const matchingChild = itemChildren.find(c =>
					c.purchaseOrders?.some(p => p.purchaseOrderNumber === poAttach.purchaseOrderNumber)
				);
				const matchingItemChild = itemChildItems.find(ic =>
					ic.purchaseOrders?.some(p => p.purchaseOrderNumber === poAttach.purchaseOrderNumber)
				);
				const detailSource = matchingChild || matchingItemChild;

				pendingWork.push({
					...detailSource,
					// PO-specific fields only
					purchaseOrderNumber: poAttach.purchaseOrderNumber,
					orderNumber: poAttach.purchaseOrderNumber,
					orderStatus: poAttach.orderStatus || 'OnOrder',
					isAttaching: true,
					systemCategoryId: detailSource?.systemCategoryId || detailSource?.inventoryItem?.systemCategoryId || 0,
					colorSelections: detailSource?.colorSelections || [],
					freeTextSelections: detailSource?.freeTextSelections || [],
					inventoryItem: detailSource?.inventoryItem || null,
					colorOptions: detailSource?.inventoryItem?.colorOptions || detailSource?.colorOptions || [],
					itemOrdered: detailSource?.itemOrdered || poAttach.inventoryItem || null
				});
			}
		});

		// Source 2: items[].childItems[].purchaseOrders[] - check each PO for non-received status (Pattern 2)
		itemChildItems.forEach(childItem => {
			const purchaseOrders = childItem.purchaseOrders || [];
			purchaseOrders.forEach(childPO => {
				if (childPO.orderStatus !== 'Received' && childPO.purchaseOrderNumber && !seenPOs.has(childPO.purchaseOrderNumber)) {
					seenPOs.add(childPO.purchaseOrderNumber);
					const matchingChild = itemChildren.find(c => c.lineItemId === childItem.lineItemId);
					const detailSource = matchingChild || childItem;

					pendingWork.push({
						...detailSource,
						// PO-specific fields only
						purchaseOrderNumber: childPO.purchaseOrderNumber,
						orderNumber: childPO.purchaseOrderNumber,
						orderStatus: childPO.orderStatus || 'OnOrder',
						isAttaching: childPO.isAttaching || false,
						systemCategoryId: detailSource.systemCategoryId || detailSource.inventoryItem?.systemCategoryId || 0,
						colorSelections: detailSource.colorSelections || [],
						freeTextSelections: detailSource.freeTextSelections || []
					});
				}
			});
		});

		// Source 3: items[].children[].purchaseOrders[] - also check here (Pattern 2)
		itemChildren.forEach(child => {
			const purchaseOrders = child.purchaseOrders || [];
			purchaseOrders.forEach(childPO => {
				if (childPO.orderStatus !== 'Received' && childPO.purchaseOrderNumber && !seenPOs.has(childPO.purchaseOrderNumber)) {
					seenPOs.add(childPO.purchaseOrderNumber);

					pendingWork.push({
						// Line item data as base
						...child,
						// PO-specific fields only
						purchaseOrderNumber: childPO.purchaseOrderNumber,
						orderNumber: childPO.purchaseOrderNumber,
						orderStatus: childPO.orderStatus || 'OnOrder',
						isAttaching: childPO.isAttaching || false,
						systemCategoryId: child.systemCategoryId || child.inventoryItem?.systemCategoryId || 0,
						colorSelections: child.colorSelections || [],
						freeTextSelections: child.freeTextSelections || []
					});
				}
			});
		});

		// Source 4: items[].purchaseOrders[] - check the main items' own attaching POs
		// Sub-items (e.g., lettering) can have both a non-attaching PO (the item's own work)
		// and an attaching PO (linking it to the parent garment). The attaching PO should appear
		// in "Work to be done" if it's still pending.
		(po?.items || []).forEach(item => {
			const purchaseOrders = item.purchaseOrders || [];
			purchaseOrders.forEach(itemPO => {
				if (itemPO.isAttaching && itemPO.orderStatus !== 'Received' && itemPO.purchaseOrderNumber && !seenPOs.has(itemPO.purchaseOrderNumber)) {
					seenPOs.add(itemPO.purchaseOrderNumber);

					// Resolve parent garment's system category from the PO's parentItem/childItems
					const parentChild = (itemPO.childItems || []).find(
						c => c.isParentItem || c.lineItemId === itemPO.parentItem?.lineItemId
					);
					const parentSystemCategoryId = parentChild?.inventoryItem?.systemCategoryId || 0;

					pendingWork.push({
						// Line item detail from computed item
						inventoryItem: item.inventoryItem || null,
						colorOptions: item.inventoryItem?.colorOptions || item.colorOptions || [],
						// PO-specific fields
						purchaseOrderNumber: itemPO.purchaseOrderNumber,
						orderNumber: itemPO.purchaseOrderNumber,
						orderStatus: itemPO.orderStatus || 'OnOrder',
						isAttaching: true,
						itemOrdered: item.itemOrdered || item.inventoryItem || null,
						colorSelections: item.colorSelections || [],
						freeTextSelections: item.freeTextSelections || [],
						quantity: item.quantity,
						lineItemId: item.lineItemId,
						systemCategoryId: item.systemCategoryId || item.itemOrdered?.systemCategoryId || 0,
						parentSystemCategoryId: parentSystemCategoryId,
						description: item.description || item.itemOrdered?.description || '',
						lettering: item.lettering || null,
						note: item.note || null,
						braidPosition: item.braidPosition || null,
						matchPreviousPoNumber: item.matchPreviousPoNumber || null,
						sizeSelections: item.sizeSelections || [],
						specialSizeSelections: item.specialSizeSelections || [],
					});
				}
			});
		});

		// Ensure all attaching entries have parentSystemCategoryId for "Attach X to Y" display
		pendingWork.forEach(item => {
			if (item.isAttaching && !item.parentSystemCategoryId) {
				item.parentSystemCategoryId = parentGarmentSystemCategoryId;
			}
		});

		return pendingWork.sort((a, b) => {
			return (a.lineItemId || 0) - (b.lineItemId || 0) || (a.isAttaching ? 1 : 0) - (b.isAttaching ? 1 : 0);
		});
	},
getChildReceivedItems(child) {
	// For optimized API, receivedItems can be:
	// 1. Directly on the child object (from childItems[] data)
	// 2. In child.purchaseOrders[] (legacy structure)
	let allReceivedItems = [];

	// Primary: receivedItems directly on the child (from getFilteredSubItems)
	if (child?.receivedItems && child.receivedItems.length > 0) {
		allReceivedItems.push(...child.receivedItems);
	}

	// Fallback: Check purchaseOrders array
	if (child?.purchaseOrders) {
		child.purchaseOrders.forEach(po => {
			if (po.receivedItems && po.receivedItems.length > 0) {
				allReceivedItems.push(...po.receivedItems);
			}
		});
	}

	return allReceivedItems;
},

hasReceivedPurchaseOrder(child) {
	// Check if this child has any purchase orders with "Received" status
	// Used to exclude items from the stock children section that should appear in SubItems section
	if (!child?.purchaseOrders || child.purchaseOrders.length === 0) {
		return false;
	}
	return child.purchaseOrders.some(po => po.orderStatus === 'Received');
},

		async getPickTicket(pickTicketId) {
			let res = await this.$apollo.query({
				query: gql`
					query GetPickTicket {
						pickTickets(where: { pickTicketId: { eq: ${pickTicketId} } }) {
							items {
								pickTicketId
								shippingDate
								trackingNumber
								printDate: lastPrinted
								type
								normalPickTicketId
								normalPickTicket {
									pickTicketId
									shippingDate
									trackingNumber
									printDate: lastPrinted
									type
								}
							}
						}
					}
				`,
				fetchPolicy: "no-cache",
			});

			let pickTicket =
				res.data && res.data.pickTickets && res.data.pickTickets.items.length === 1
					? res.data.pickTickets.items[0]
					: null;

			return pickTicket;
		},

		async getProcessingPickTicket(pickTicketId) {
			let res = await this.$apollo.query({
				query: gql`
					query GetPickTicket {
						pickTickets(where: { normalPickTicketId: { eq: ${pickTicketId} } }) {
							items {
								pickTicketId
								shippingDate
								trackingNumber
								printDate: lastPrinted
								type
								normalPickTicketId
								normalPickTicket {
									pickTicketId
									shippingDate
									trackingNumber
									printDate: lastPrinted
									type
								}
							}
						}
					}
				`,
				fetchPolicy: "no-cache",
			});

			let pickTicket =
				res.data && res.data.pickTickets && res.data.pickTickets.items.length === 1
					? res.data.pickTickets.items[0]
					: null;

			return pickTicket;
		},

		async getPurchaseOrderByLineItemId(lineItemId) {
			// Use session cache if available for optimized performance
			if (this.sessionCache) {
				return await this.sessionCache.getPurchaseOrderByLineItemId(lineItemId);
			}

			// Fallback to original implementation if cache not available
			const res = await this.$apollo.query({
				fetchPolicy: "no-cache",
				query: PURCHASE_ORDER_BY_LINEITEMID,
				variables: { lineItemId: lineItemId },
			});

			return res.data.purchaseOrderByLineItemId;
		},

		/**
		 * Optimized version of fetchComputedItems using parallel processing
		 * Uses same recursive logic as original but with batch fetching and caching
		 */
		async fetchComputedItemsOptimized(pickTicketId) {
			if (!this.sessionCache) {
				// Fall back to original if cache not available
				return await this.fetchComputedItems(pickTicketId);
			}

			console.log(`[PickTicketPrint] Starting optimized fetch for pick ticket ${pickTicketId}`);
			const startTime = performance.now();

			// Use the same recursive processing as original method
			// Function to process an item and its children recursively
			const processItem = async (item, pickTicketId) => {
				let itemsArr = [];
				item.purchaseOrders = [];

				// Check if the item matches the pickTicketId and process it
				if (item.pickTicketId && item.pickTicketId === pickTicketId) {
					const bin = await this.renderBin(item.itemId, item.sizeSelections);
					// Use cached method instead of direct query
					let purchaseOrders = (await this.getPurchaseOrderByLineItemId(item.lineItemId)) ?? [];

					// this may be a stocked item with process type children items
					// populate data in a different way
					if (purchaseOrders.length === 0 && item.children) {
						for (let child of item.children) {
							// Use cached method instead of direct query
							let po = await this.getPurchaseOrderByLineItemId(child.lineItemId);
							let clonedItem = JSON.parse(
								JSON.stringify({
									...item,
									bin: bin,
									lineNumber: this.getLineNumber(item.lineItemId),
								})
							);

							if (po && po.length > 0) {
								clonedItem.childItems = [...po];
								purchaseOrders.push(clonedItem);
							}

							child.bin = await this.renderBin(child.itemId, child.sizeSelections);
						}
					}

					// Process purchase orders with cached vendor data
					for (let po of purchaseOrders) {
						po = await this.getWithPOStatus(po, po.purchaseOrderId);
						// Use cached getVendorAddress method
						const vendorAddress = await this.getVendorAddress(po.vendorId);
						po.vendorAddress = vendorAddress;
					}

					item.purchaseOrders.push(...purchaseOrders);

					itemsArr.push({
						...item,
						bin: bin,
						lineNumber: this.getLineNumber(item.lineItemId),
					});
				}

				// Process children recursively
				if (item.children) {
					for (const child of item.children) {
						const childItems = await processItem(child, pickTicketId);
						itemsArr.push(...childItems);
					}
				}

				return itemsArr;
			};

			// Process all items
			let result = [];
			for (const item of this.printInfo.items) {
				const processedItems = await processItem(item, pickTicketId);
				result.push(...processedItems);
			}

			const endTime = performance.now();
			const metrics = this.sessionCache ? this.sessionCache.getMetrics() : null;
			console.log(`[PickTicketPrint] Optimized fetch completed in ${(endTime - startTime).toFixed(2)}ms`);
			if (metrics) {
				console.log(`[PickTicketPrint] Cache metrics:`, metrics);
			}

			return result;
		},

		async fetchComputedItems(pickTicketId) {
			// Function to process an item and its children recursively
			const processItem = async (item, pickTicketId) => {
				let itemsArr = [];
				item.purchaseOrders = [];

				// Check if the item matches the pickTicketId and process it
				if (item.pickTicketId && item.pickTicketId === pickTicketId) {
					const bin = await this.renderBin(item.itemId, item.sizeSelections);
					let purchaseOrders = (await this.getPurchaseOrderByLineItemId(item.lineItemId)) ?? [];

					// this may be a stocked item with process type children items
					// populate data in a different way
					if (purchaseOrders.length === 0 && item.children) {
						for (let child of item.children) {
							let po = await this.getPurchaseOrderByLineItemId(child.lineItemId);
							let clonedItem = JSON.parse(
								JSON.stringify({
									...item,
									bin: bin,
									lineNumber: this.getLineNumber(item.lineItemId),
								})
							);

							clonedItem.childItems = [];

							if (po && po.length > 0) {
								let childPO = JSON.parse(JSON.stringify(po));
								clonedItem.childItems.push(...childPO);
								let updatedPO = {
									...clonedItem,
								};
								purchaseOrders.push(updatedPO);
							}
						}
					}

					for (let po of purchaseOrders) {
						if (po.id) {
							po = await this.getWithPOStatus(po, po.id);
						}

						if (po.vendorId) {
							po.vendorAddress = await this.getVendorAddress(po.vendorId);
						}

						let parentItem = po.parentItem;
						let parentPoId = parentItem?.parentPoId;

						if (parentPoId) {
							const parentRes = await this.$apollo.query({
								fetchPolicy: "no-cache",
								query: PURCHASE_ORDER_BY_ID,
								variables: { id: parentPoId },
							});

							if (parentRes && parentRes.data && parentRes.data.purchaseOrderById) {
								const items = parentRes.data.purchaseOrderById.items;
								const matchingItem = items.find(
									(item) => item.salesOrderLineItemId === parentItem.parentLineItemId
								);
								if (matchingItem) {
									const parentColorOptions = await this.getInventoryColorOptions(items);

									parentItem = {
										...parentItem,
										...matchingItem,
										purchaseOrderNumber: parentRes.data.purchaseOrderById.purchaseOrderNumber,
										receivedItems: parentRes.data.purchaseOrderById.receivedItems,
										colorSelections: parentColorOptions
											.find((co) => co.inventoryItemId === matchingItem.itemOrdered?.inventoryItemId)
											?.colorOptions.map((colorOption) => {
												let selection = matchingItem.colors.find(
													(c) => c.colorOptionId === colorOption.colorOptionId
												);
												if (!selection) {
													selection = matchingItem.colors.find(
														(c) => c.colorOption === colorOption.name
													);
												}

												if (!selection) {
													selection = matchingItem.freeTextSelections.find(
														(c) => c.colorOptionId === colorOption.colorOptionId
													);
												}

												if (selection) {
													selection.colorDescription =
														colorOption.colorDescription || colorOption.description;
													selection.colorOption = colorOption.name;
													selection.colorOptionId = colorOption.colorOptionId;
													selection.colorOptionPosition = colorOption.position;
												}

												return selection;
											})
											.sort((a, b) => (a.colorOptionPosition ?? 0) - (b.colorOptionPosition ?? 0)),
									};

									if (parentItem.itemOrdered?.inventoryItemId) {
										parentItem.bin = await this.renderBin(
											parentItem.itemOrdered.inventoryItemId,
											parentItem.sizeSelections
										);
									}

									parentItem = await this.getWithPOStatus(parentItem, parentPoId);
								}
							}
						}

						let childItems = po.childItems;
						let updatedChildItems = [];
						if (childItems && childItems.length > 0) {
							for (let childItem of childItems) {
								childItem.childPoId = childItem.childPoId ?? childItem.id;
								if (childItem.childPoId) {
									const childRes = await this.$apollo.query({
										fetchPolicy: "no-cache",
										query: PURCHASE_ORDER_BY_ID,
										variables: { id: childItem.childPoId },
									});

									if (childRes && childRes.data && childRes.data.purchaseOrderById) {
										const items = childRes.data.purchaseOrderById.items;
										const matchingChildItem = items.find(
											(item) => item.salesOrderLineItemId === childItem.lineItemId
										);
										if (matchingChildItem) {
											const childColorOptions = await this.getInventoryColorOptions(items);

											childItem = {
												...childItem,
												...matchingChildItem,
												vendorId: childRes.data.purchaseOrderById.vendorId,
												isAttaching: childItem?.isAttaching ?? false,
												purchaseOrderNumber: childRes.data.purchaseOrderById.purchaseOrderNumber,
												receivedItems: childRes.data.purchaseOrderById.receivedItems,
												colorSelections:
													childColorOptions && childColorOptions.length > 0
														? childColorOptions
																.find(
																	(co) =>
																		co.inventoryItemId ===
																		matchingChildItem.itemOrdered?.inventoryItemId
																)
																?.colorOptions.map((colorOption) => {
																	let selection = matchingChildItem.colors.find(
																		(c) => c.colorOptionId === colorOption.colorOptionId
																	);
																	if (!selection) {
																		selection = matchingChildItem.colors.find(
																			(c) => c.colorOption === colorOption.name
																		);
																	}

																	if (!selection) {
																		selection = matchingChildItem.freeTextSelections.find(
																			(c) => c.colorOptionId === colorOption.colorOptionId
																		);
																	}

																	if (selection) {
																		selection.colorDescription =
																			colorOption.colorDescription || colorOption.description;
																		selection.colorOption = colorOption.name;
																		selection.colorOptionId = colorOption.colorOptionId;
																		selection.colorOptionPosition = colorOption.position;
																	}

																	return selection;
																})
																.sort((a, b) => (a.colorOptionPosition ?? 0) - (b.colorOptionPosition ?? 0))
														: [],
											};

											if (childItem.itemOrdered?.inventoryItemId) {
												childItem.bin = await this.renderBin(
													childItem.itemOrdered.inventoryItemId,
													childItem.sizeSelections
												);
											}

											childItem = await this.getWithPOStatus(childItem, childItem.childPoId);

											childItem.vendorAddress = await this.getVendorAddress(childItem.vendorId);

											updatedChildItems.push(childItem);
										}
									}
								}
							}
						}

						let attachItems = po.attachItems;
						let updatedAttachItems = [];
						if (attachItems && attachItems.length > 0) {
							for (let attachItem of attachItems) {
								if (attachItem.attachPoId) {
									const attachRes = await this.$apollo.query({
										fetchPolicy: "no-cache",
										query: PURCHASE_ORDER_BY_ID,
										variables: { id: attachItem.attachPoId },
									});

									if (attachRes && attachRes.data && attachRes.data.purchaseOrderById) {
										const items = attachRes.data.purchaseOrderById.items;
										const matchingAttachItem = items.find(
											(item) => item.salesOrderLineItemId === attachItem.lineItemId
										);
										if (matchingAttachItem) {
											const childColorOptions = await this.getInventoryColorOptions(items);

											attachItem = {
												...attachItem,
												...matchingAttachItem,
												...attachRes.data.purchaseOrderById,
												vendorId: attachRes.data.purchaseOrderById.vendorId,
												isAttaching: true,
												colorSelections:
													childColorOptions && childColorOptions.length > 0
														? childColorOptions
																.find(
																	(co) =>
																		co.inventoryItemId ===
																		matchingAttachItem.itemOrdered?.inventoryItemId
																)
																?.colorOptions.map((colorOption) => {
																	let selection = matchingAttachItem.colors.find(
																		(c) => c.colorOptionId === colorOption.colorOptionId
																	);
																	if (!selection) {
																		selection = matchingAttachItem.colors.find(
																			(c) => c.colorOption === colorOption.name
																		);
																	}

																	if (!selection) {
																		selection = matchingAttachItem.freeTextSelections.find(
																			(c) => c.colorOptionId === colorOption.colorOptionId
																		);
																	}

																	if (selection) {
																		selection.colorDescription =
																			colorOption.colorDescription || colorOption.description;
																		selection.colorOption = colorOption.name;
																		selection.colorOptionId = colorOption.colorOptionId;
																		selection.colorOptionPosition = colorOption.position;
																	}

																	return selection;
																})
																.sort((a, b) => (a.colorOptionPosition ?? 0) - (b.colorOptionPosition ?? 0))
														: [],
											};

											if (attachItem.itemOrdered?.inventoryItemId) {
												attachItem.bin = await this.renderBin(
													attachItem.itemOrdered.inventoryItemId,
													attachItem.sizeSelections
												);
											}

											attachItem = await this.getWithPOStatus(attachItem, attachItem.attachPoId);

											attachItem.vendorAddress = await this.getVendorAddress(attachItem.vendorId);

											updatedAttachItems.push(attachItem);
										}
									}
								}
							}
						}

						const colorOptions = await this.getInventoryColorOptions(po.items ?? [po]);

						let purchaseOrder = {
							...po,
							purchaseOrderId: po.id,
							dropShip: po.dropShip,
							expectedShipDate: po.expectedDate,
							orderNumber: po.purchaseOrderNumber,
							orderDate: po.purchaseOrderDate,
							customerNumber: po.salesOrderId,
							notes: po.notes
								? [
										...po.notes.map((note) => {
											return {
												...note,
												noteDate: note.createdAt,
												note: note.noteText,
												author: note.createdBy,
											};
										}),
								  ]
								: [],
							items: po.items
								? [
										...po.items.map((item) => ({
											...item,
											quantity: item.quantity,
											unitPrice: item.unitPrice,
											totalSizes: item.totalSizes,
											hasSizes: item.hasSizes,
											itemOrdered: item.itemOrdered,
											sizeSelections: [
												...item.sizes.map((size) => ({
													...size,
													name: size.size,
													length: size.length,
													quantity: size.quantity,
												})),
											],
											specialSizeSelections: item.specialSizes,
											colorSelections:
												colorOptions && colorOptions.length > 0
													? colorOptions
															.find((co) => co.inventoryItemId === item.itemOrdered?.inventoryItemId)
															?.colorOptions.map((colorOption) => {
																let selection = item.colors.find(
																	(c) => c.colorOptionId === colorOption.colorOptionId
																);

																if (!selection) {
																	selection = item.colors.find(
																		(c) => c.colorOption === colorOption.name
																	);
																}

																if (!selection) {
																	selection = item.freeTextSelections.find(
																		(c) => c.colorOptionId === colorOption.colorOptionId
																	);
																}

																if (selection) {
																	selection.colorDescription =
																		colorOption.colorDescription || colorOption.description;
																	selection.colorOption = colorOption.name;
																	selection.colorOptionId = colorOption.colorOptionId;
																	selection.colorOptionPosition = colorOption.position;
																}

																return selection;
															})
															.sort((a, b) => (a.colorOptionPosition ?? 0) - (b.colorOptionPosition ?? 0))
													: [],
											styleCode: item.itemOrdered?.styleCode,
											systemCategoryId:
												this.$store.state.systemCategories.systemCategories.find(
													(el) => el.name === item.itemOrdered?.systemCategory
												)?.systemCategoryId || 0,
											description: item.itemOrdered?.description,
											inventoryItemId: item.itemOrdered?.inventoryItemId,
											vendorCost: item.unitPrice,
											parentItem: parentItem,
											childItems: updatedChildItems,
											attachItems: updatedAttachItems,
										})),
								  ]
								: [
										{
											...po,
											quantity: po.quantity,
											unitPrice: po.unitPrice,
											totalSizes: po.totalSizes,
											hasSizes: po.hasSizes,
											itemOrdered: po.itemOrdered,
											sizeSelections: po.sizeSelections
												? po.sizeSelections
												: po.sizes
												? [
														...po.sizes?.map((size) => ({
															...size,
															name: size.size,
															length: size.length,
															quantity: size.quantity,
														})),
												  ]
												: [],
											specialSizeSelections: po.specialSizes,
											colorSelections: po.colorSelections
												? await Promise.all(
														(po.colorSelections ?? [])
															.map(async (cs) => {
																if (cs.colorId) {
																	let colorWithMeta = await this.getColor(cs.colorId);
																	if (colorWithMeta) {
																		cs.color = colorWithMeta?.description;
																	}
																}
																return cs;
															})
															.sort((a, b) => (a.colorOptionPosition ?? 0) - (b.colorOptionPosition ?? 0))
												  )
												: colorOptions?.length > 0
												? colorOptions
														.find(
															(co) =>
																co.inventoryItemId ===
																(po?.itemOrdered?.inventoryItemId ?? po.itemId)
														)
														?.colorOptions.map((colorOption) => {
															let selection = po.colors.find(
																(c) => c.colorOptionId === colorOption.colorOptionId
															);

															if (!selection) {
																selection = po.colors.find(
																	(c) => c.colorOption === colorOption.name
																);
															}

															if (!selection) {
																selection = po.freeTextSelections.find(
																	(c) => c.colorOptionId === colorOption.colorOptionId
																);
															}

															if (selection) {
																selection.colorDescription =
																	colorOption.colorDescription || colorOption.description;
																selection.colorOption = colorOption.name;
																selection.colorOptionId = colorOption.colorOptionId;
																selection.colorOptionPosition = colorOption.position;
															}

															return selection;
														})
														.sort((a, b) => (a.colorOptionPosition ?? 0) - (b.colorOptionPosition ?? 0))
												: [],
											styleCode: po?.itemOrdered?.styleCode ?? po.styleCode,
											systemCategoryId: po.systemCategoryId
												? po.systemCategoryId
												: this.$store.state.systemCategories.systemCategories.find(
														(el) => el.name === po?.itemOrdered?.systemCategory
												  )?.systemCategoryId || 0,
											description: po?.itemOrdered?.description ?? po.description,
											inventoryItemId: po?.itemOrdered?.inventoryItemId ?? po.itemId,
											vendorCost: po.unitPrice,
											parentItem: parentItem,
											childItems: updatedChildItems,
											attachItems: updatedAttachItems,
										},
								  ],
						};

						for (let binpo of purchaseOrder.items) {
							binpo.bin = await this.renderBin(
								binpo?.itemOrdered?.inventoryItemId ?? binpo.itemId,
								binpo.sizeSelections
							);
						}

						item.purchaseOrders.push(purchaseOrder);
					}

					// get children bins
					if (item?.children?.length > 0) {
						for (let child of item.children) {
							const childBin = await this.renderBin(child.itemId, child.sizeSelections);
							child.bin = childBin;
						}
					}

					itemsArr.push({
						...item,
						bin: bin,
						lineNumber: this.getLineNumber(item.lineItemId),
					});
				}

				// Recursively process child items, if any
				// if (item.children && item.children.length > 0) {
				// 	for (let childItem of item.children) {
				// 		const childItems = await processItem(childItem, pickTicketId);
				// 		itemsArr = itemsArr.concat(childItems);
				// 	}
				// }

				return itemsArr;
			};

			if (!this.printInfo.items || this.printInfo.items.length === 0) {
				return [];
			}

			// Process each item in the array
			let itemsArr = [];
			for (let item of this.printInfo.items) {
				let lineItem = this.lineItems.find((li) => li.lineItemId === item.lineItemId);

				if (lineItem?.type?.toLowerCase() === "package" && item?.children?.length > 0) {
					for (let packageItem of item.children) {
						const processedPackageItems = await processItem(packageItem, pickTicketId);
						itemsArr = itemsArr.concat(processedPackageItems);
					}
				} else {
					const processedItems = await processItem(item, pickTicketId);
					itemsArr = itemsArr.concat(processedItems);
				}
			}

			// Sort items by lineNumber
			itemsArr.sort((a, b) => a.lineNumber - b.lineNumber);

			return itemsArr;
		},

		async getInventoryColorOptions(items) {
			const inventoryIdsWithColors = items.reduce(
				(acc, el) =>
					el.colors?.length > 0 ||
					el.colorSelections?.length > 0 ||
					el.freeTextSelections?.length > 0
						? [...acc, el?.itemOrdered?.inventoryItemId ?? el.itemId]
						: acc,
				[]
			);
			let colorOptions = {};
			if (inventoryIdsWithColors.length) {
				const inventories = await this.$apollo.query({
					fetchPolicy: "no-cache",
					query: GET_INVENTORY_COLOR_OPTIONS_IDS,
					variables: {
						where: {
							inventoryItemId: {
								in: inventoryIdsWithColors,
							},
						},
					},
				});
				return inventories.data.response.items;
			}
			return colorOptions;
		},

		async getColor(colorId) {
			const color = await this.$apollo.query({
				fetchPolicy: "no-cache",
				query: gql`
					query GetColorById($Id: Int!) {
						colorById(id: $Id) {
							colorId
							label
							description
							hexCode
							isVisible
							isRetired
							isCustomColor
							colorPaletteId
							colorPalette {
								colorPaletteId
								name
								description
								upcharge
								isTemplate
								templateColorPaletteId
								colorOptionId
							}
						}
					}
				`,
				variables: {
					Id: colorId,
				},
			});

			return color.data.colorById;
		},

		async getWithPOStatus(po, purchaseOrderId) {
			// Use session cache if available for optimized performance
			if (this.sessionCache) {
				return await this.sessionCache.getWithPOStatus(po, purchaseOrderId);
			}

			// Fallback to original implementation if cache not available
			const poRes = await this.$apollo.query({
				query: SEARCH_PURCHASE_ORDERS,
				variables: {
					where: {
						purchaseOrderId: {
							eq: purchaseOrderId,
						},
					},
				},
				fetchPolicy: "no-cache",
			});

			let poResults = poRes.data.purchaseOrderListings.items;
			if (poResults && poResults.length === 1) {
				po = { ...po, ...poResults[0] };
			}

			return po;
		},

		async getVendorAddress(vendorId) {
			// Use session cache if available for optimized performance
			if (this.sessionCache) {
				return await this.sessionCache.getVendorAddress(vendorId);
			}

			// Fallback to original implementation if cache not available
			try {
				const res = await this.$apollo.query({
					fetchPolicy: "no-cache",
					query: VENDOR_BY_ID,
					variables: {
						id: vendorId,
					},
				});

				let vendorSearch = res.data.response;

				return vendorSearch.addresses?.find((el) => el.isPrimaryAddress) ||
					(vendorSearch.addresses && vendorSearch.addresses.length > 0)
					? vendorSearch.addresses[0]
					: {};
			} catch (error) {
				console.log(error);
			}
		},

		async getLineItems() {
			const res = await this.$http.get(`/api/orders/${this.orderId}/lineItems`);
			return res.data.lineItems;
		},

		flattenLineItems(lineItems) {
			let itemsArr = [];
			lineItems.forEach((li) => itemsArr.push(...this.flattenLineItem(li)));

			return itemsArr;
		},

		flattenLineItem(lineItem) {
			let lineItems = [lineItem];

			if (lineItem.children?.length > 0) {
				lineItem.children.forEach((child) => {
					lineItems.push(...this.flattenLineItem(child));
				});
			}

			return lineItems;
		},

		toLineItemSummary(lineItem) {
			return {
				...lineItem,
				children: lineItem.children?.map((c) => this.toLineItemSummary(c)),
			};
		},

		mergeAndSortSelections(lineItem) {
			// Merge colorSelections and freeTextSelections. Dedupe because a free text
			// can arrive via both arrays when the item was edited in-session (#1431)
			const mergedSelections = dedupeSelections([
				...(lineItem.colorSelections || []),
				...(lineItem.freeTextSelections || []).map((selection) => ({
					...selection,
					colorName: selection.text, // Using 'text' as 'colorName' for display purposes
				})),
			]);

			// Get colorOptions from the correct nested location with null safety
			const colorOptions = lineItem.inventoryItem?.colorOptions || lineItem.colorOptions || [];

			const mappedWithPosition = mergedSelections.map((selection) => {
				const colorOption = colorOptions.find(
					(option) => option.colorOptionId === selection.colorOptionId
				);
				return {
					...selection,
					position: colorOption ? colorOption.position : null,
					colorOption: selection.colorOption || colorOption?.name || null,
					colorDescription: selection.colorDescription || colorOption?.description || null,
				};
			});

			const sortedSelections = mappedWithPosition.sort(
				(a, b) => (a.position || 0) - (b.position || 0)
			);

			return sortedSelections;
		},

		/**
		 * OPTIMIZED: Uses batch GraphQL query for pick tickets while reusing existing order data loader
		 *
		 * Performance improvements:
		 * - Legacy: 65+ API calls (13+ per line item for purchase orders, bins, vendors)
		 * - Optimized: 2 API calls (1 for order data, 1 batch query for all pick ticket data)
		 * - Eliminates N+1 query patterns for line items and purchase orders
		 * - Reduces latency and server load dramatically
		 */
		async loadPickTicketData() {
			const startTime = performance.now();
			console.log('[PickTicketPrintOptimized] Starting OPTIMIZED batch data load');

			this.pickTicketIds =
				this.pickTicketIds.length > 1 ? this.pickTicketIds.sort((a, b) => a - b) : this.pickTicketIds;

			// Determine which pick tickets to load
			const targetPickTicketIds = this.pickTicketIds.length > 0
				? this.pickTicketIds
				: this.distinctPickTicketIds;

			if (!targetPickTicketIds || targetPickTicketIds.length === 0) {
				console.warn('[PickTicketPrintOptimized] No pick ticket IDs to load');
				return;
			}

			try {
				// Single batch GraphQL query to fetch ALL data (order, customer, pick tickets, line items, POs, inventory)
				const result = await this.$apollo.query({
					query: GET_PICK_TICKET_PRINT_DATA,
					variables: {
						orderId: this.orderId,
						pickTicketIds: targetPickTicketIds,
					},
					fetchPolicy: 'network-only',
				});

				if (!result.data?.pickTicketPrintData) {
					throw new Error('No data returned from batch query');
				}

				const batchData = result.data.pickTicketPrintData;
				console.log('[PickTicketPrintOptimized] Batch data received:', {
					order: !!batchData.order,
					pickTicketsCount: batchData.pickTickets?.length || 0,
					supportingData: !!batchData.supportingData,
				});

				// Use order data from batch query (already has correct nested customer structure)
				this.printInfo = batchData.order;

				// Extract top-level fields from nested customer structure (matching legacy behavior)
				// This ensures template references to printInfo.organization, printInfo.customerNumber, etc. work correctly
				if (batchData.order.customer && batchData.order.customer.customer) {
					this.printInfo.organization = batchData.order.customer.customer.organization;
					this.printInfo.customerNumber = batchData.order.customer.customer.customerNumber;
					this.printInfo.customerId = batchData.order.customer.customer.customerId;
					this.printInfo.contactId = batchData.order.customer.contactId;
					this.printInfo.billToId = batchData.order.customer.billTo;
					this.printInfo.shipToId = batchData.order.customer.shipTo;
					this.printInfo.salesTaxId = batchData.order.customer.customer.salesTaxId || 0;
				}

				// Merge supporting data into printInfo for template access
				if (batchData.supportingData) {
					this.printInfo.processTypes = batchData.supportingData.processTypes || [];
					this.printInfo.letterPositions = batchData.supportingData.letterPositions || [];
					this.printInfo.shippingMethods = batchData.supportingData.shippingMethods || [];
					this.printInfo.paymentTerms = batchData.supportingData.paymentTerms || [];
					this.printInfo.paymentMethods = batchData.supportingData.paymentMethods || [];
					this.printInfo.salesReps = batchData.supportingData.salesReps || [];
				}

				// Setup line items from batch data
				this.lineItems = this.transformLineItemsData(batchData.pickTickets);

				// Process pick tickets from batch data
				for (const pickTicketData of batchData.pickTickets) {
					await this.loadSinglePickTicketFromBatchData(pickTicketData);
				}

				const endTime = performance.now();
				const duration = (endTime - startTime).toFixed(2);
				console.log(`[PickTicketPrintOptimized] OPTIMIZED batch load completed in ${duration}ms with 1 API call (vs 65+ in legacy)`);

			} catch (error) {
				console.error('[PickTicketPrintOptimized] Error in batch data load:', error);
				// Fall back to legacy method if batch query fails
				console.warn('[PickTicketPrintOptimized] Falling back to legacy method');
				await this.loadPickTicketDataLegacy();
			}
		},

		/**
		 * Transform batch line items data
		 */
		transformLineItemsData(pickTickets) {
			if (!pickTickets) return [];

			const allLineItems = [];

			for (const pickTicket of pickTickets) {
				for (const lineItem of pickTicket.lineItems || []) {
					const flatItem = {
						...lineItem,
						// Use line number from backend instead of recalculating
						lineNumber: lineItem.lineNumber,
						pickTicketId: pickTicket.pickTicketId,
						shippingDate: pickTicket.shippingDate,
						trackingNumber: pickTicket.trackingNumber,
					};
					allLineItems.push(this.toLineItemSummary(flatItem));
				}
			}

			return allLineItems;
		},

		/**
		 * Process a single pick ticket from batch data
		 */
		async loadSinglePickTicketFromBatchData(pickTicketData) {
			// Transform line items to match expected format
			const computedItems = pickTicketData.lineItems.map(lineItem => {
				// Calculate bin using size-specific logic (must happen before spread to have access to full lineItem)
				const binValue = this.calculateBin(lineItem);

				return {
					...lineItem,
					itemId: lineItem.inventoryItem.inventoryItemId,
					styleCode: lineItem.inventoryItem.styleCode,
					vendorPartNumber: lineItem.inventoryItem.vendorPartNumber,
					description: lineItem.inventoryItem.description,
					stockedItem: lineItem.inventoryItem.stockItems,
					systemCategoryId: lineItem.inventoryItem.systemCategoryId,
					systemCategory: lineItem.inventoryItem.systemCategory,
					processTypeId: lineItem.inventoryItem.processTypeId,
					// Use calculated bin based on size selections
					bin: binValue,
					colorOptions: lineItem.inventoryItem.colorOptions || [],
					sizeChart: lineItem.inventoryItem.sizeChart,
					subItems: lineItem.inventoryItem.subItems || [],
					// Transform to match expected structure
					colorSelections: lineItem.colorSelections || [],
					// Map sizeName to name and include length for renderSizes function compatibility
					sizeSelections: (lineItem.sizeSelections || []).map(size => ({
						...size,
						name: size.sizeName || size.name || size.size, // Map sizeName to name
						size: size.sizeName || size.name || size.size, // Also set size as fallback
						length: size.length // Include length from backend
					})),
					specialSizeSelections: lineItem.specialSizeSelections || [],
					purchaseOrders: lineItem.purchaseOrders || [],
					children: (lineItem.children || []).map(child => {
						// Calculate bin for child items too
						const childBin = this.calculateBin(child);
						return {
							...child,
							itemId: child.inventoryItem?.inventoryItemId,
							styleCode: child.inventoryItem?.styleCode,
							description: child.inventoryItem?.description,
							itemOrdered: child.inventoryItem,
							bin: childBin,
							// Also map sizeSelections for child items
							sizeSelections: (child.sizeSelections || []).map(size => ({
								...size,
								name: size.sizeName || size.name || size.size,
								size: size.sizeName || size.name || size.size,
								length: size.length // Include length from backend
							})),
						};
					}),
				};
			});

			const shipDate = computedItems.length > 0 ? pickTicketData.shippingDate : null;
			const pos = [];

			for (const item of computedItems) {
				if (item.purchaseOrders && item.purchaseOrders.length > 0) {
					pos.push(...item.purchaseOrders);
				}
			}

			console.log('[PickTicketPrintOptimized] Processing pickTicket data:', {
				pickTicketId: pickTicketData.pickTicketId,
				computedItemsCount: computedItems.length,
				purchaseOrdersFound: pos.length,
				firstItem: computedItems[0]
			});

			// Create purchase order object with items property for template compatibility
			let purchaseOrder = {};
			if (pos.length > 0) {
				// Prefer non-attaching PO as the main purchase order (the item's "own" PO)
				// Attaching POs link sub-items to parent garments and shouldn't drive the main display
				const mainPO = pos.find(po => !po.isAttaching) || pos[0];
				purchaseOrder = { ...mainPO };

				// Debug log to see what data we have
				console.log('[PickTicketPrintOptimized] Purchase Order Data from batch query:', {
					orderNumber: purchaseOrder.purchaseOrderNumber,
					orderStatus: purchaseOrder.orderStatus,
					vendor: purchaseOrder.vendor,
					vendorAddress: purchaseOrder.vendorAddress,
					hasItems: !!purchaseOrder.items
				});

				// Map vendor object to vendor string for template compatibility
				if (purchaseOrder.vendor && typeof purchaseOrder.vendor === 'object') {
					// Store the vendor name as a string while preserving the original object
					purchaseOrder.vendorObj = purchaseOrder.vendor;
					purchaseOrder.vendor = purchaseOrder.vendor.companyName || '';
				}

				// Map purchaseOrderNumber to orderNumber for template compatibility
				if (purchaseOrder.purchaseOrderNumber && !purchaseOrder.orderNumber) {
					purchaseOrder.orderNumber = purchaseOrder.purchaseOrderNumber;
				}

				if (!purchaseOrder.items) {
					purchaseOrder.items = computedItems;
				} else {
					// PO has its own items, but they don't have children with status info
					// Merge children from computedItems into purchaseOrder.items
					purchaseOrder.items = purchaseOrder.items.map(poItem => {
						// Find matching item in computedItems by lineItemId or salesOrderLineItemId
						const matchingComputedItem = computedItems.find(ci =>
							ci.lineItemId === poItem.salesOrderLineItemId ||
							ci.lineItemId === poItem.lineItemId
						);
						if (matchingComputedItem && matchingComputedItem.children) {
							// Add children from computedItems (which has status info)
							return { ...poItem, children: matchingComputedItem.children };
						}
						return poItem;
					});
				}
			} else {
				// No purchase order, create a minimal one with items for the template
				console.log('[PickTicketPrintOptimized] No purchase orders found, creating minimal purchaseOrder with items:', computedItems);
				purchaseOrder = {
					items: computedItems,
					receivedItems: [],
					isAttaching: false,
					orderStatus: '',
					vendor: '',
					vendorAddress: null,
					orderNumber: null
				};
			}

			// Ensure each item has childItems and attachItems arrays to prevent iteration errors
			if (purchaseOrder.items) {
				purchaseOrder.items = purchaseOrder.items.map(item => {
					// Start with the original item
					const processedItem = { ...item };

					// Map inventoryItem to itemOrdered for template compatibility
					if (item.inventoryItem && !item.itemOrdered) {
						processedItem.itemOrdered = item.inventoryItem;
						// Also copy key properties to the item level for direct access
						processedItem.styleCode = item.inventoryItem.styleCode;
						processedItem.vendorPartNumber = item.inventoryItem.vendorPartNumber;
						processedItem.description = item.inventoryItem.description;
						processedItem.stockedItem = item.inventoryItem.stockItems;
						processedItem.systemCategoryId = item.inventoryItem.systemCategoryId;
						processedItem.systemCategory = item.inventoryItem.systemCategory;
						processedItem.processTypeId = item.inventoryItem.processTypeId;
						// Check both locations for bin data
						processedItem.bin = item.bin || item.inventoryItem.bin?.name || '';
						processedItem.colorOptions = item.inventoryItem.colorOptions || [];
						processedItem.sizeChart = item.inventoryItem.sizeChart;
						processedItem.subItems = item.inventoryItem.subItems || [];
					}

					// Sort purchaseOrders so non-attaching PO comes first
					// This ensures item.purchaseOrders[0] references in the template use the item's own PO
					if (item.purchaseOrders && item.purchaseOrders.length > 1) {
						processedItem.purchaseOrders = [...item.purchaseOrders].sort(
							(a, b) => (a.isAttaching ? 1 : 0) - (b.isAttaching ? 1 : 0)
						);
					}

					// Preserve children data (has status field for pending detection)
					if (item.children && Array.isArray(item.children)) {
						processedItem.children = item.children;
					} else {
						processedItem.children = [];
					}

					// Process childItems - prefer existing childItems (which have full PO data like purchaseOrderNumber)
					// Only create from children if childItems doesn't exist
					if (item.childItems && Array.isArray(item.childItems)) {
						processedItem.childItems = item.childItems.map(child => {
							const processedChild = {
								...child,
								vendor: child.vendor?.companyName || child.vendor || '',
								vendorAddress: child.vendorAddress || null
							};

							// Map inventoryItem to itemOrdered if needed
							if (child.inventoryItem && !child.itemOrdered) {
								processedChild.itemOrdered = child.inventoryItem;
								processedChild.styleCode = child.inventoryItem.styleCode;
								processedChild.vendorPartNumber = child.inventoryItem.vendorPartNumber;
								processedChild.description = child.inventoryItem.description;
								processedChild.stockedItem = child.inventoryItem.stockItems;
								processedChild.systemCategoryId = child.inventoryItem.systemCategoryId;
								processedChild.systemCategory = child.inventoryItem.systemCategory;
								processedChild.processTypeId = child.inventoryItem.processTypeId;
								// Check both locations for bin data
								processedChild.bin = child.bin || child.inventoryItem.bin?.name || '';
								processedChild.colorOptions = child.inventoryItem.colorOptions || [];
							}

							return processedChild;
						});
					} else if (item.children && Array.isArray(item.children)) {
						// Fallback: create childItems from children if no existing childItems
						processedItem.childItems = item.children.map(child => {
							const processedChild = {
								...child,
								vendor: child.vendor?.companyName || child.vendor || '',
								vendorAddress: child.vendorAddress || null
							};

							// Map inventoryItem to itemOrdered for child items too
							if (child.inventoryItem && !child.itemOrdered) {
								processedChild.itemOrdered = child.inventoryItem;
								processedChild.styleCode = child.inventoryItem.styleCode;
								processedChild.vendorPartNumber = child.inventoryItem.vendorPartNumber;
								processedChild.description = child.inventoryItem.description;
								processedChild.stockedItem = child.inventoryItem.stockItems;
								processedChild.systemCategoryId = child.inventoryItem.systemCategoryId;
								processedChild.systemCategory = child.inventoryItem.systemCategory;
								processedChild.processTypeId = child.inventoryItem.processTypeId;
								// Check both locations for bin data
								processedChild.bin = child.bin || child.inventoryItem.bin?.name || '';
								processedChild.colorOptions = child.inventoryItem.colorOptions || [];
							}

							return processedChild;
						});
					} else {
						processedItem.childItems = [];
					}

					// Process attachItems if they exist
					if (item.attachItems && Array.isArray(item.attachItems)) {
						processedItem.attachItems = item.attachItems.map(attach => {
							const processedAttach = {
								...attach,
								vendor: attach.vendor?.companyName || attach.vendor || '',
								vendorAddress: attach.vendorAddress || null
							};

							// Map inventoryItem to itemOrdered for attach items too
							if (attach.inventoryItem && !attach.itemOrdered) {
								processedAttach.itemOrdered = attach.inventoryItem;
								processedAttach.styleCode = attach.inventoryItem.styleCode;
								processedAttach.vendorPartNumber = attach.inventoryItem.vendorPartNumber;
								processedAttach.description = attach.inventoryItem.description;
								processedAttach.stockedItem = attach.inventoryItem.stockItems;
								processedAttach.systemCategoryId = attach.inventoryItem.systemCategoryId;
								processedAttach.systemCategory = attach.inventoryItem.systemCategory;
								processedAttach.processTypeId = attach.inventoryItem.processTypeId;
								// Check both locations for bin data
								processedAttach.bin = attach.bin || attach.inventoryItem.bin?.name || '';
								processedAttach.colorOptions = attach.inventoryItem.colorOptions || [];
							}

							return processedAttach;
						});
					} else {
						processedItem.attachItems = [];
					}

					// Ensure bin exists at the item level if not already set
					// Check both direct bin and nested inventoryItem.bin.name
					if (!processedItem.bin) {
						processedItem.bin = item.bin || item.inventoryItem?.bin?.name || '';
					}

					// Build parentItem from purchase order data for template rendering
					// (Legacy path sets this via PURCHASE_ORDER_BY_ID queries;
					//  batch path must enrich from the PO's childItems data instead)
					if (item.purchaseOrders && item.purchaseOrders.length > 0) {
						const poWithParent = item.purchaseOrders.find(po => po.parentItem);
						if (poWithParent && poWithParent.parentItem) {
							const rawParent = poWithParent.parentItem;
							// Find the parent's full item data from childItems (marked isParentItem)
							const parentChildData = (poWithParent.childItems || []).find(
								c => c.isParentItem || c.lineItemId === rawParent.lineItemId
							);

							processedItem.parentItem = {
								...rawParent,
								parentPoId: rawParent.purchaseOrderId,
								purchaseOrderNumber: parentChildData?.purchaseOrderNumber || '',
								itemOrdered: parentChildData?.inventoryItem || rawParent.itemOrdered || null,
								colorSelections: parentChildData?.colorSelections || [],
								sizeSelections: (parentChildData?.sizeSelections || []).map(s => ({
									...s, name: s.name || s.sizeName || ''
								})),
								sizes: (parentChildData?.sizeSelections || []).map(s => ({
									...s, name: s.name || s.sizeName || '', size: s.sizeName || s.name || ''
								})),
								specialSizes: parentChildData?.specialSizeSelections || [],
								quantity: parentChildData?.quantity || rawParent.quantity || 0,
								receivedItems: [],
								note: parentChildData?.note || null,
								matchPreviousPoNumber: parentChildData?.matchPreviousPoNumber || null,
								braidPosition: parentChildData?.braidPosition || null,
								lettering: parentChildData?.lettering || null,
								bin: '',
							};
						}
					}

					return processedItem;
				});
			}

			// Log the final purchaseOrder structure
			console.log('[PickTicketPrintOptimized] Final purchaseOrder structure:', {
				hasItems: !!purchaseOrder.items,
				itemsCount: purchaseOrder.items?.length || 0,
				firstItem: purchaseOrder.items?.[0],
				purchaseOrder: purchaseOrder
			});

			const finalPickTicket = {
				pickTicketId: pickTicketData.pickTicketId,
				type: pickTicketData.type,
				normalPickTicketId: pickTicketData.normalPickTicketId,
				shippingDate: pickTicketData.shippingDate,
				trackingNumber: pickTicketData.trackingNumber,
				items: computedItems,
				purchaseOrder: purchaseOrder,
				shipDate: shipDate,
			};

			console.log('[PickTicketPrintOptimized] Adding pickTicket to array:', {
				pickTicketId: finalPickTicket.pickTicketId,
				type: finalPickTicket.type,
				hasItems: !!finalPickTicket.items && finalPickTicket.items.length > 0,
				hasPurchaseOrder: !!finalPickTicket.purchaseOrder,
				purchaseOrderHasItems: !!finalPickTicket.purchaseOrder?.items && finalPickTicket.purchaseOrder.items.length > 0
			});

			this.pickTickets.push(finalPickTicket);
		},

		/**
		 * Legacy fallback method (kept for error recovery)
		 */
		async loadPickTicketDataLegacy() {
			this.printInfo = await getOrderInfo(this.orderId, this.$apolloProvider.defaultClient, this);

			let lineItems = await this.getLineItems();
			let flattenedLineItems = this.flattenLineItems(lineItems);
			flattenedLineItems.forEach((li, index) => (li.lineNumber = index + 1));
			this.lineItems = flattenedLineItems.map((li) => this.toLineItemSummary(li));

			if (this.pickTicketIds.length === 0) {
				for (let pickTicketId of this.distinctPickTicketIds) {
					await this.loadSinglePickTicketLegacy(pickTicketId);
				}
			} else if (this.pickTicketIds.length > 0) {
				for (let pickTicketId of this.pickTicketIds) {
					await this.loadSinglePickTicketLegacy(pickTicketId, true);
				}
			}
		},

		async loadSinglePickTicketLegacy(pickTicketId, isSpecific = false) {
			let pickTicket = await this.getPickTicket(pickTicketId);
			let computedItems = await this.fetchComputedItems(pickTicketId);

			if (isSpecific && pickTicket.type?.toLowerCase() === "normal" && computedItems.length === 0) {
				let processingPickTicket = await this.getProcessingPickTicket(pickTicketId);
				if (processingPickTicket) {
					computedItems = await this.fetchComputedItems(processingPickTicket.pickTicketId);
				}
			}

			let shipDate =
				computedItems && computedItems.length > 0 ? computedItems[0].shippingDate : null;
			let pos = [];

			for (let item of computedItems) {
				pos.push(...item.purchaseOrders);
			}

			// Create purchase order object with items property for template compatibility
			let purchaseOrder = {};
			if (pos.length > 0) {
				// Prefer non-attaching PO as the main purchase order (the item's "own" PO)
				const mainPO = pos.find(po => !po.isAttaching) || pos[0];
				purchaseOrder = { ...mainPO };

				// Debug log to see what data we have (legacy fallback)
				console.log('[PickTicketPrintOptimized] Purchase Order Data from legacy fallback:', {
					orderNumber: purchaseOrder.purchaseOrderNumber,
					orderStatus: purchaseOrder.orderStatus,
					vendor: purchaseOrder.vendor,
					vendorAddress: purchaseOrder.vendorAddress,
					hasItems: !!purchaseOrder.items
				});

				// Map vendor object to vendor string for template compatibility
				if (purchaseOrder.vendor && typeof purchaseOrder.vendor === 'object') {
					// Store the vendor name as a string while preserving the original object
					purchaseOrder.vendorObj = purchaseOrder.vendor;
					purchaseOrder.vendor = purchaseOrder.vendor.companyName || '';
				}

				// Map purchaseOrderNumber to orderNumber for template compatibility
				if (purchaseOrder.purchaseOrderNumber && !purchaseOrder.orderNumber) {
					purchaseOrder.orderNumber = purchaseOrder.purchaseOrderNumber;
				}

				if (!purchaseOrder.items) {
					purchaseOrder.items = computedItems;
				}
			} else {
				// No purchase order, create a minimal one with items for the template
				console.log('[PickTicketPrintOptimized] No purchase orders found, creating minimal purchaseOrder with items:', computedItems);
				purchaseOrder = {
					items: computedItems,
					receivedItems: [],
					isAttaching: false,
					orderStatus: '',
					vendor: '',
					vendorAddress: null,
					orderNumber: null
				};
			}

			// Ensure each item has childItems and attachItems arrays to prevent iteration errors
			if (purchaseOrder.items) {
				purchaseOrder.items = purchaseOrder.items.map(item => {
					// Start with the original item
					const processedItem = { ...item };

					// Map inventoryItem to itemOrdered for template compatibility
					if (item.inventoryItem && !item.itemOrdered) {
						processedItem.itemOrdered = item.inventoryItem;
						// Also copy key properties to the item level for direct access
						processedItem.styleCode = item.inventoryItem.styleCode;
						processedItem.vendorPartNumber = item.inventoryItem.vendorPartNumber;
						processedItem.description = item.inventoryItem.description;
						processedItem.stockedItem = item.inventoryItem.stockItems;
						processedItem.systemCategoryId = item.inventoryItem.systemCategoryId;
						processedItem.systemCategory = item.inventoryItem.systemCategory;
						processedItem.processTypeId = item.inventoryItem.processTypeId;
						// Check both locations for bin data
						processedItem.bin = item.bin || item.inventoryItem.bin?.name || '';
						processedItem.colorOptions = item.inventoryItem.colorOptions || [];
						processedItem.sizeChart = item.inventoryItem.sizeChart;
						processedItem.subItems = item.inventoryItem.subItems || [];
					}

					// Sort purchaseOrders so non-attaching PO comes first
					// This ensures item.purchaseOrders[0] references in the template use the item's own PO
					if (item.purchaseOrders && item.purchaseOrders.length > 1) {
						processedItem.purchaseOrders = [...item.purchaseOrders].sort(
							(a, b) => (a.isAttaching ? 1 : 0) - (b.isAttaching ? 1 : 0)
						);
					}

					// Preserve children data (has status field for pending detection)
					if (item.children && Array.isArray(item.children)) {
						processedItem.children = item.children;
					} else {
						processedItem.children = [];
					}

					// Process childItems - prefer existing childItems (which have full PO data like purchaseOrderNumber)
					// Only create from children if childItems doesn't exist
					if (item.childItems && Array.isArray(item.childItems)) {
						processedItem.childItems = item.childItems.map(child => {
							const processedChild = {
								...child,
								vendor: child.vendor?.companyName || child.vendor || '',
								vendorAddress: child.vendorAddress || null
							};

							// Map inventoryItem to itemOrdered if needed
							if (child.inventoryItem && !child.itemOrdered) {
								processedChild.itemOrdered = child.inventoryItem;
								processedChild.styleCode = child.inventoryItem.styleCode;
								processedChild.vendorPartNumber = child.inventoryItem.vendorPartNumber;
								processedChild.description = child.inventoryItem.description;
								processedChild.stockedItem = child.inventoryItem.stockItems;
								processedChild.systemCategoryId = child.inventoryItem.systemCategoryId;
								processedChild.systemCategory = child.inventoryItem.systemCategory;
								processedChild.processTypeId = child.inventoryItem.processTypeId;
								// Check both locations for bin data
								processedChild.bin = child.bin || child.inventoryItem.bin?.name || '';
								processedChild.colorOptions = child.inventoryItem.colorOptions || [];
							}

							return processedChild;
						});
					} else if (item.children && Array.isArray(item.children)) {
						// Fallback: create childItems from children if no existing childItems
						processedItem.childItems = item.children.map(child => {
							const processedChild = {
								...child,
								vendor: child.vendor?.companyName || child.vendor || '',
								vendorAddress: child.vendorAddress || null
							};

							// Map inventoryItem to itemOrdered for child items too
							if (child.inventoryItem && !child.itemOrdered) {
								processedChild.itemOrdered = child.inventoryItem;
								processedChild.styleCode = child.inventoryItem.styleCode;
								processedChild.vendorPartNumber = child.inventoryItem.vendorPartNumber;
								processedChild.description = child.inventoryItem.description;
								processedChild.stockedItem = child.inventoryItem.stockItems;
								processedChild.systemCategoryId = child.inventoryItem.systemCategoryId;
								processedChild.systemCategory = child.inventoryItem.systemCategory;
								processedChild.processTypeId = child.inventoryItem.processTypeId;
								// Check both locations for bin data
								processedChild.bin = child.bin || child.inventoryItem.bin?.name || '';
								processedChild.colorOptions = child.inventoryItem.colorOptions || [];
							}

							return processedChild;
						});
					} else {
						processedItem.childItems = [];
					}

					// Process attachItems if they exist
					if (item.attachItems && Array.isArray(item.attachItems)) {
						processedItem.attachItems = item.attachItems.map(attach => {
							const processedAttach = {
								...attach,
								vendor: attach.vendor?.companyName || attach.vendor || '',
								vendorAddress: attach.vendorAddress || null
							};

							// Map inventoryItem to itemOrdered for attach items too
							if (attach.inventoryItem && !attach.itemOrdered) {
								processedAttach.itemOrdered = attach.inventoryItem;
								processedAttach.styleCode = attach.inventoryItem.styleCode;
								processedAttach.vendorPartNumber = attach.inventoryItem.vendorPartNumber;
								processedAttach.description = attach.inventoryItem.description;
								processedAttach.stockedItem = attach.inventoryItem.stockItems;
								processedAttach.systemCategoryId = attach.inventoryItem.systemCategoryId;
								processedAttach.systemCategory = attach.inventoryItem.systemCategory;
								processedAttach.processTypeId = attach.inventoryItem.processTypeId;
								// Check both locations for bin data
								processedAttach.bin = attach.bin || attach.inventoryItem.bin?.name || '';
								processedAttach.colorOptions = attach.inventoryItem.colorOptions || [];
							}

							return processedAttach;
						});
					} else {
						processedItem.attachItems = [];
					}

					// Ensure bin exists at the item level if not already set
					// Check both direct bin and nested inventoryItem.bin.name
					if (!processedItem.bin) {
						processedItem.bin = item.bin || item.inventoryItem?.bin?.name || '';
					}

					return processedItem;
				});
			}

			this.pickTickets.push({
				...pickTicket,
				pickTicketId: pickTicketId,
				items: computedItems,
				purchaseOrder: purchaseOrder,
				shipDate: shipDate,
			});

			if (!isSpecific && pickTicket.normalPickTicketId > 0 && pickTicket.normalPickTicket) {
				this.pickTickets.push({
					...pickTicket.normalPickTicket,
					pickTicketId: pickTicket.normalPickTicketId,
					items: computedItems,
					purchaseOrder: {},
					shipDate: shipDate,
				});
			}
		},

		retryLoad() {
			// Clean up existing cache before retry
			if (this.sessionCache) {
				console.log('[PickTicketPrint] Destroying cache before retry');
				this.sessionCache.destroy();
				this.sessionCache = null;
			}

			this.showErrorDialog = false;
			this.errorMessage = '';
			this.errorDetails = '';
			this.loadingTimeout = false;
			this.pickTickets = [];
			this.lineItems = [];
			this.mounted();
		},
	},
	computed: {
		totalQuantity() {
			return this.computedItemsTable.reduce((total, lineItem) => total + lineItem.quantity, 0);
		},
		// Returns true when all pick tickets have completed PDF rendering
		pagedJsComplete() {
			if (this.pickTicketIds.length === 0) return false;
			return this.pickTicketIds.every(id => this.pdfReadySet.has(Number(id)));
		},
		printedBy() {
			// Priority 1: Override prop from auto-print URL (user who initiated the action) - use initials
			if (this.printedByOverride) {
				return `by ${this.extractInitials(this.printedByOverride)}`;
			}

			// Priority 2: Logged-in user from store (manual print) - use initials (Issue #1123)
			let user = this.$store.getters.userInfo;
			if (user?.initials) {
				return `by ${user.initials}`;
			} else if (user?.firstName && user?.lastName) {
				return `by ${(user.firstName[0] + user.lastName[0]).toUpperCase()}`;
			} else if (user?.username) {
				return `by ${user.username.substring(0, 2).toUpperCase()}`;
			}

			// Fallback for auto-print context where no user session exists
			return "by AP";
		},
		computedOrderContact() {
			let contact = {
				name: "",
				email: "",
				cellPhoneNumber: "",
				workPhoneNumber: "",
			};

			let customer = null;

			if (this.printInfo.quoteCustomer) {
				customer = this.printInfo.quoteCustomer;
			}
			if (this.printInfo.customer) {
				customer = this.printInfo.customer;
			}

			if (this.printInfo.contactId && customer?.customer?.contacts) {
				const contactObj = customer.customer.contacts.find(
					(contact) => contact.contactId == this.printInfo.contactId
				);
				if (contactObj) {
					contact.name = `${contactObj.firstName} ${contactObj.lastName}`;
					contact.email = contactObj.email;
					contact.cellPhoneNumber = contactObj.cellPhoneNumber;
					contact.workPhoneNumber = contactObj.workPhoneNumber;
				}
			}

			return contact;
		},
		resolveCustomer() {
			if (this.printInfo.quoteCustomer) return this.printInfo.quoteCustomer;
			if (this.printInfo.customer) return this.printInfo.customer;
			return null;
		},
		computedAddress() {
			let result = {
				address: "",
				cityState: "",
				contactName: "",
				contactEmail: "",
				contactWorkPhone: "",
				contactCellPhone: "",
				organization: "",
				department: "",
			};

			const customer = this.resolveCustomer;
			if (!customer?.customer?.addresses) return result;

			let addressObj = this.printInfo.billToId
				? customer.customer.addresses.find(a => a.addressId == this.printInfo.billToId)
				: null;

			if (!addressObj) {
				addressObj = customer.customer.addresses.find(a => a.isPrimaryAddress == true)
					|| (customer.customer.addresses.length > 0 ? customer.customer.addresses[0] : null);
			}

			if (addressObj) {
				result.address = `${addressObj.addressLine1 || ''} ${addressObj.addressLine2 || ''}`.trim();
				result.cityState = `${addressObj.city || ''}, ${addressObj.state || ''} ${addressObj.postalCode || ''}`;
				result.organization = addressObj.organization || '';
				result.department = addressObj.department || '';

				if (addressObj.contact) {
					result.contactName = `${addressObj.contact.firstName} ${addressObj.contact.lastName}`.trim();
					result.contactEmail = addressObj.contact.email || '';
					result.contactWorkPhone = addressObj.contact.workPhoneNumber || '';
					result.contactCellPhone = addressObj.contact.cellPhoneNumber || '';
				} else if (addressObj.contactId && customer?.customer?.contacts) {
					const c = customer.customer.contacts.find(c => c.contactId == addressObj.contactId);
					if (c) {
						result.contactName = `${c.firstName} ${c.lastName}`.trim();
						result.contactEmail = c.email || '';
						result.contactWorkPhone = c.workPhoneNumber || '';
						result.contactCellPhone = c.cellPhoneNumber || '';
					}
				}

				if (!result.contactName) {
					const fallback = this.computedOrderContact;
					result.contactName = fallback.name;
					result.contactEmail = fallback.email;
					result.contactWorkPhone = fallback.workPhoneNumber;
					result.contactCellPhone = fallback.cellPhoneNumber;
				}
			}

			return result;
		},
		computedShipTo() {
			let result = {
				address: "",
				cityState: "",
				contactName: "",
				contactEmail: "",
				contactWorkPhone: "",
				contactCellPhone: "",
				organization: "",
			};

			const customer = this.resolveCustomer;
			if (!customer || !customer.customer || !customer.customer.addresses) return result;

			const addressObj = customer.customer.addresses.find(
				a => a.addressId == customer.shipTo
			);

			if (addressObj) {
				result.address = `${addressObj.addressLine1 || ''} ${addressObj.addressLine2 || ''}`.trim();
				result.cityState = `${addressObj.city || ''}, ${addressObj.state || ''} ${addressObj.postalCode || ''}`.trim();
				result.organization = addressObj.organization || '';

				if (addressObj.contact) {
					result.contactName = `${addressObj.contact.firstName} ${addressObj.contact.lastName}`.trim();
					result.contactEmail = addressObj.contact.email || '';
					result.contactWorkPhone = addressObj.contact.workPhoneNumber || '';
					result.contactCellPhone = addressObj.contact.cellPhoneNumber || '';
				} else if (addressObj.contactId && customer?.customer?.contacts) {
					const c = customer.customer.contacts.find(c => c.contactId == addressObj.contactId);
					if (c) {
						result.contactName = `${c.firstName} ${c.lastName}`.trim();
						result.contactEmail = c.email || '';
						result.contactWorkPhone = c.workPhoneNumber || '';
						result.contactCellPhone = c.cellPhoneNumber || '';
					}
				}

				if (!result.contactName) {
					const fallback = this.computedOrderContact;
					result.contactName = fallback.name;
					result.contactEmail = fallback.email;
					result.contactWorkPhone = fallback.workPhoneNumber;
					result.contactCellPhone = fallback.cellPhoneNumber;
				}
			}

			return result;
		},
		distinctPickTicketIds() {
			const uniquePickTicketIds = new Set();
			this.lineItems.forEach((item) => {
				if (item.pickTicketId !== undefined && item.pickTicketId !== null) {
					uniquePickTicketIds.add(item.pickTicketId);
				}
			});

			return [...uniquePickTicketIds].sort((a, b) => a - b);
		},
		distinctPurchaseOrders() {
			const allItems = this.pickTickets
				.flatMap((ticket) => ticket.items)
				.flatMap((item) => item.purchaseOrders);

			const uniqueItems = Array.from(new Set(allItems.map((item) => JSON.stringify(item)))).map(
				(str) => JSON.parse(str)
			);

			return uniqueItems;
		},
	},
	computed: {
		isFormValid() {
			return this.printerSelection && this.copies && this.copies > 0;
		},
		totalQuantity() {
			return this.computedItemsTable.reduce((total, lineItem) => total + lineItem.quantity, 0);
		},
		printedBy() {
			// Priority 1: Override prop from auto-print URL (user who initiated the action) - use initials
			if (this.printedByOverride) {
				return `by ${this.extractInitials(this.printedByOverride)}`;
			}

			// Priority 2: Logged-in user from store (manual print) - use initials (Issue #1123)
			let user = this.$store.getters.userInfo;
			if (user?.initials) {
				return `by ${user.initials}`;
			} else if (user?.firstName && user?.lastName) {
				return `by ${(user.firstName[0] + user.lastName[0]).toUpperCase()}`;
			} else if (user?.username) {
				return `by ${user.username.substring(0, 2).toUpperCase()}`;
			}

			// Fallback for auto-print context where no user session exists
			return "by AP";
		},
		computedOrderContact() {
			let contact = {
				name: "",
				email: "",
				cellPhoneNumber: "",
				workPhoneNumber: "",
			};

			let customer = null;

			if (this.printInfo.quoteCustomer) {
				customer = this.printInfo.quoteCustomer;
			}
			if (this.printInfo.customer) {
				customer = this.printInfo.customer;
			}

			if (this.printInfo.contactId && customer?.customer?.contacts) {
				const contactObj = customer.customer.contacts.find(
					(contact) => contact.contactId == this.printInfo.contactId
				);
				if (contactObj) {
					contact.name = `${contactObj.firstName} ${contactObj.lastName}`;
					contact.email = contactObj.email;
					contact.cellPhoneNumber = contactObj.cellPhoneNumber;
					contact.workPhoneNumber = contactObj.workPhoneNumber;
				}
			}

			return contact;
		},
		resolveCustomer() {
			if (this.printInfo.quoteCustomer) return this.printInfo.quoteCustomer;
			if (this.printInfo.customer) return this.printInfo.customer;
			return null;
		},
		computedAddress() {
			let result = {
				address: "",
				cityState: "",
				contactName: "",
				contactEmail: "",
				contactWorkPhone: "",
				contactCellPhone: "",
				organization: "",
				department: "",
			};

			const customer = this.resolveCustomer;
			if (!customer?.customer?.addresses) return result;

			let addressObj = this.printInfo.billToId
				? customer.customer.addresses.find(a => a.addressId == this.printInfo.billToId)
				: null;

			if (!addressObj) {
				addressObj = customer.customer.addresses.find(a => a.isPrimaryAddress == true)
					|| (customer.customer.addresses.length > 0 ? customer.customer.addresses[0] : null);
			}

			if (addressObj) {
				result.address = `${addressObj.addressLine1 || ''} ${addressObj.addressLine2 || ''}`.trim();
				result.cityState = `${addressObj.city || ''}, ${addressObj.state || ''} ${addressObj.postalCode || ''}`;
				result.organization = addressObj.organization || '';
				result.department = addressObj.department || '';

				if (addressObj.contact) {
					result.contactName = `${addressObj.contact.firstName} ${addressObj.contact.lastName}`.trim();
					result.contactEmail = addressObj.contact.email || '';
					result.contactWorkPhone = addressObj.contact.workPhoneNumber || '';
					result.contactCellPhone = addressObj.contact.cellPhoneNumber || '';
				} else if (addressObj.contactId && customer?.customer?.contacts) {
					const c = customer.customer.contacts.find(c => c.contactId == addressObj.contactId);
					if (c) {
						result.contactName = `${c.firstName} ${c.lastName}`.trim();
						result.contactEmail = c.email || '';
						result.contactWorkPhone = c.workPhoneNumber || '';
						result.contactCellPhone = c.cellPhoneNumber || '';
					}
				}

				if (!result.contactName) {
					const fallback = this.computedOrderContact;
					result.contactName = fallback.name;
					result.contactEmail = fallback.email;
					result.contactWorkPhone = fallback.workPhoneNumber;
					result.contactCellPhone = fallback.cellPhoneNumber;
				}
			}

			return result;
		},
		computedShipTo() {
			let result = {
				address: "",
				cityState: "",
				contactName: "",
				contactEmail: "",
				contactWorkPhone: "",
				contactCellPhone: "",
				organization: "",
			};

			const customer = this.resolveCustomer;
			if (!customer || !customer.customer || !customer.customer.addresses) return result;

			const addressObj = customer.customer.addresses.find(
				a => a.addressId == customer.shipTo
			);

			if (addressObj) {
				result.address = `${addressObj.addressLine1 || ''} ${addressObj.addressLine2 || ''}`.trim();
				result.cityState = `${addressObj.city || ''}, ${addressObj.state || ''} ${addressObj.postalCode || ''}`.trim();
				result.organization = addressObj.organization || '';

				if (addressObj.contact) {
					result.contactName = `${addressObj.contact.firstName} ${addressObj.contact.lastName}`.trim();
					result.contactEmail = addressObj.contact.email || '';
					result.contactWorkPhone = addressObj.contact.workPhoneNumber || '';
					result.contactCellPhone = addressObj.contact.cellPhoneNumber || '';
				} else if (addressObj.contactId && customer?.customer?.contacts) {
					const c = customer.customer.contacts.find(c => c.contactId == addressObj.contactId);
					if (c) {
						result.contactName = `${c.firstName} ${c.lastName}`.trim();
						result.contactEmail = c.email || '';
						result.contactWorkPhone = c.workPhoneNumber || '';
						result.contactCellPhone = c.cellPhoneNumber || '';
					}
				}

				if (!result.contactName) {
					const fallback = this.computedOrderContact;
					result.contactName = fallback.name;
					result.contactEmail = fallback.email;
					result.contactWorkPhone = fallback.workPhoneNumber;
					result.contactCellPhone = fallback.cellPhoneNumber;
				}
			}

			return result;
		},
		distinctPickTicketIds() {
			const uniquePickTicketIds = new Set();
			this.lineItems.forEach((item) => {
				if (item.pickTicketId !== undefined && item.pickTicketId !== null) {
					uniquePickTicketIds.add(item.pickTicketId);
				}
			});

			return [...uniquePickTicketIds].sort((a, b) => a - b);
		},
		distinctPurchaseOrders() {
			const allItems = this.pickTickets
				.flatMap((ticket) => ticket.items)
				.flatMap((item) => item.purchaseOrders);

			const uniqueItems = Array.from(new Set(allItems.map((item) => JSON.stringify(item)))).map(
				(str) => JSON.parse(str)
			);

			return uniqueItems;
		},
	},
	beforeDestroy() {
		Object.values(this.pdfUrls).forEach(url => URL.revokeObjectURL(url));
		if (this.sessionCache) {
			const metrics = this.sessionCache.getMetrics();
			console.log('[PickTicketPrint] Session ending - Performance metrics:', metrics);
			this.sessionCache.destroy();
			this.sessionCache = null;
		}
	},
	async mounted() {
		// the order view keeps its scroll position when routing to the print preview
		window.scrollTo(0, 0);

		// Initialize session-scoped cache for this print session
		this.sessionCache = new PickTicketSessionCache(this.$apollo);
		console.log('[PickTicketPrint] Starting new print session with optimized caching');

		this.loading = true;
		const timeoutDuration = 30000; // 30 seconds

		try {
			await Promise.race([
				this.loadPickTicketData(),
				new Promise((_, reject) =>
					setTimeout(() => {
						this.loadingTimeout = true;
						reject(new Error('Data loading timeout after 30 seconds'));
					}, timeoutDuration)
				)
			]);

			// Log performance metrics after data loading completes
			if (this.sessionCache) {
				const metrics = this.sessionCache.getMetrics();
				console.log('[PickTicketPrint] Data loading complete - Performance metrics:', metrics);
				console.log(`[PickTicketPrint] Loaded ${this.pickTickets.length} pick tickets with ${metrics.apiCalls} API calls, ${metrics.cacheHits} cache hits (${metrics.cacheHitRate} cache hit rate)`);
			}

			// Load printers from API
			try {
				const response = await this.$http.get(`/api/print/printers`);
				const printersData = response.data.printers || response.data;
				this.printers = printersData.map((printer) => ({
					printerId: printer.id,
					text: `${printer.name} (${printer.location || "No location"})`,
					status: printer.status,
				}));

				// Set default values for print modal
				if (this.printers.length > 0) {
					const onlinePrinter = this.printers.find((p) => p.status === "Online");
					this.printerSelection = onlinePrinter
						? onlinePrinter.printerId
						: this.printers[0].printerId;
				}
				this.copies = 1;
			} catch (error) {
				console.error("Error loading printers:", error);
			}

			// If we got here, data loaded successfully - generate print doc
			this.$nextTick(async () => {
				await new Promise(resolve => setTimeout(resolve, 2000));
				await this.generatePrintDoc();
				this.loading = false;

				if (this.skipPreview) {
					this.$emit('pagedjs-complete');
				}
			});

		} catch (error) {
			console.error('Error loading pick ticket data:', error);
			this.loading = false;
			this.errorMessage = this.loadingTimeout
				? 'Loading took too long and timed out.'
				: 'Failed to load pick ticket data.';
			this.errorDetails = error.message || String(error);
			this.showErrorDialog = true;
		}
	},
};
</script>

<style lang="scss" scoped>
.button-group {
	display: flex;
	align-items: center;
}

.message-input {
	width: 100%;
}
#print-frame,
.print-frame {
	display: block;
	background-color: #f5f5f5;
	width: 100%;
	max-width: 900px;
	aspect-ratio: 8.5 / 11.5;
	margin: 0 auto;
	border: none;
}

// keep the action buttons visible below the fixed app bar while scrolling the document
.actions-col {
	position: sticky;
	top: 64px;
	z-index: 4;
	background-color: $color-gray-light;

	@media (max-width: 959px) {
		top: 56px;
	}
}

.actions {
	display: flex;
	width: 100%;
	justify-content: flex-end;

	.v-btn {
		background-color: $color-white;
		border-color: $color-gray;
		text-transform: initial;

		&:not(:last-child) {
			margin-right: 0.8rem;
		}
	}
}

.print {
	position: relative;
	background-color: $color-white;
	line-height: 14pt;
	font-family: Arial, Helvetica, "Nimbus Sans L", "Liberation Sans", sans-serif !important;
	width: 100%;
	//remove for printing css
	max-width: 816px;
	min-height: 1056px;
	margin: auto;
	padding: 0.6cm;

	&-wrapper {
		height: 100%;
	}

	&-heading {
		display: block;
		margin-bottom: 12px;

		p {
			font-size: 12pt;
			margin-bottom: 8px !important;
		}

		&-logo {
			display: block;
			width: 100%;
			text-align: center;

			img {
				max-width: 70%;
				height: auto;
			}
		}

		&-type {
			display: inline-block;
			width: 100%;
			padding: 8px;
			margin-bottom: 8px;
			text-align: center;
			font-size: 14pt;
			background-color: $color-black;
			color: $color-white;
		}

		&-left {
			display: inline-block;
			width: 25%;
			text-align: left;
			vertical-align: top;
		}

		&-center {
			display: inline-block;
			width: 50%;
			vertical-align: top;
		}

		&-right {
			display: inline-block;
			width: 25%;
			text-align: right;
			vertical-align: top;
		}
	}

	&-info {
		display: block;
		margin-bottom: 8px;

		&-container-split {
			display: inline-block;
			width: 48%;

			&:last-child {
				margin-left: 4%;
			}

			table {
				width: 100%;
				border-spacing: 0px;
				font-size: 11pt;
				border: 1px solid $color-black;

				thead {
					tr {
						page-break-inside: avoid;
						th {
							padding: 8px;
							background-color: $color-black;
							color: $color-white;
							text-align: center;
							font-weight: normal;
						}
					}
				}

				tbody {
					tr {
						page-break-inside: avoid;
						td {
							padding: 20px;
							padding-left: 50px;

							p.addr-city-state {
								margin-bottom: 20px !important;
							}
						}
					}
				}
			}
		}

		&-container-full {
			display: block;
			width: 100%;

			table {
				width: 100%;
				border-spacing: 0px;
				font-size: 11pt;
				border: 1px solid $color-black;
				thead {
					tr {
						page-break-inside: avoid;
						th {
							padding: 8px;
							background-color: $color-black;
							color: $color-white;
							text-align: center;
							font-weight: normal;
						}
					}
				}

				tbody {
					tr {
						page-break-inside: avoid;
						td {
							padding: 8px;
							text-align: center;
							border-right: 1px solid $color-black;

							&:last-child {
								border-right: none;
							}
						}
					}
				}
			}
		}
	}

	&-items {
		display: block;

		&-container {
			display: block;
			width: 100%;

			table {
				width: 100%;
				border-spacing: 0px;
				border: 1px solid $color-black;

				thead {
					tr {
						page-break-inside: avoid;
						th {
							font-size: 11pt;
							padding: 4px 2px;
							background-color: $color-black;
							color: $color-white;
							text-align: center;
							font-weight: normal;
						}
					}
				}

				tbody {
					tr {
						page-break-inside: avoid;
						td {
							font-size: 10pt;
							vertical-align: top;
							padding: 4px;
							text-align: center;
							border-right: 1px solid $color-black;

							&:last-child {
								border-right: none;
							}

							&:nth-child(1) {
								width: 50px;
							}
							&:nth-child(2) {
								width: 16%;
							}
							&:nth-child(3) {
								width: 16%;
								text-align: left;
							}
							&:nth-child(4) {
								width: 16%;
							}
							&:nth-child(5) {
								width: 25%;
							}
							&:nth-child(6) {
								width: 10%;
							}
							&:nth-child(7) {
								text-align: right;
							}
						}
					}
				}
			}
		}

		&-title {
			font-weight: 700;
		}

		&-value {
			font-weight: 700;
		}
	}
}

.print-modal {
	&-form {
		display: flex;
		flex-flow: column wrap;

		.form-input {
			margin: 0.75rem 0;

			.number-input {
				width: 14rem;
				flex: initial;
			}
		}
	}
}

.no-list-style {
	list-style: none;
	width: 100%;
	padding: 0;
	display: flex;
	flex-direction: column;

	li {
		width: 100%;
		margin-bottom: 100px;
	}
}
</style>
